import React, { createRef } from "react";
import './single-select.scss';
import CommonUtils from "../../../../utility/common-utilities";
import QuestionTitle from "../question-title/question-title";
import QuestionImage from "../../../common/cw-question-image/cw-question-image";
import { getThemeImageSource, getImageSource } from "../../../../utility/image-source";
import { ImageConstants, Constants } from "../../../../constants/constants";
import SharedThemeCategory from "../../../../../shared-storage/category-theme";
import RadioGroup from "../../radio/radio-group";
import AssessmentFooter from "../../assessment-footer/assessment-footer";
import SummarySoultions from "../../../common/summary-solution/summary-solution";
// import DotPagination from "../../dot-pagination/dot-pagination";
import SharedStaticText from "../../../../../shared-storage/static-text-store";
// import AnswerTab from "../../../my-assessment-result/question/answer-tab/answer-tab";
import ReactTooltip from "react-tooltip";
import StudentAnsweredStatusBoard from "../../student-answered-status-board/student-answered-status-board";
import AssessmentQuote from "../quotes-title/quotes-title";
import Leaderboard from "../leaderboard/leaderboard";
import LayoutShared from "../../../common/layout-shared/layout-shared";
import ToasterComponent from "../../../common/cw-toaster-component/cw-toaster-component";
import timeUpSound from "../../../../assets/audio/time-up-sound.mp3";
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import HomeworkForClickerPracticeApi from "../../../../apis/homework-for-clicker-practice";
import IndexedDBHelperV2 from "../../../../offline/apis/indexDBManager-v2";
import ImagePreview from "../../../common/image-preview/image-preview";
import leaderBoardDisplaySound from "../../../../assets/audio/elo_cleared.mp3";
import ScaledCanvas from "../../../clicker-practice-dynamic-resolution/scaled-canvas";
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);



class SingleSelect extends React.Component {

    state = {
        content: null, attachments: [], showSolution: true, showOptions: false, isListening: false, studentList: [],
        stopReceivingStudentSignal: this.props.showPreviousQuestion ? true : false,
        showTimer: false,
        viewOverallLeaderboard: false,
        showStudentResponse: false,
        pauseCount: 0,
        pauseDetails: [], // Array to store each pause's details
        lastPausedAt: null, // To track when the timer was paused,
        isPlaying: false,
        isPortOpen: false,
        tabIndex: 1,
        showBarGraph: true,
        isVideoPlaying: false,
        startTime: Date.now(),
        studentListHash: {},
        caseStudySkillHash: [],
        readOnlyStudentList: [],
        clickData: [],
        receiveTeacherInput: false,
        zoomLevel: 1,
        restartKey: 0,
        allowKey: false,
        showQuestionTimerCountdown: true,
        isReadonlyReload: false,
        gifSrc: getImageSource(ImageConstants.CHAPTER_COMPLETED_GIF),
        playGif: false,
        studentClickedCount: 0
    };

    isValid = false;
    originalContent = {};
    answerTickCount = 0;
    optionsHash = {};
    userIdAnswerHash = {}


    constructor(props) {
        super(props)
        this.correctAnswerStaticText = SharedStaticText.getStaticText('correctAnswerPopUpScreen');
        this.inCorrectAnswerStaticText = SharedStaticText.getStaticText('wrongAnswerPopUpScreen');
        this.originalContent = JSON.parse(JSON.stringify((this.props.content)));
        this.scaledCanvasRef = React.createRef();
        this.audio = new Audio(timeUpSound);
        // console.log(this.props.isReadOnly)
        this.audioForBarChart = new Audio(leaderBoardDisplaySound)

        if (this.props.isReadOnly) {
            // let optionsHash = this.props.optionsHashForReadOnly
            let questionDetails = this.props.questions.filter(item => item.details._id === this.props.content._id)
            let optionsHash = questionDetails[0].optionsHash
            console.log(optionsHash)
            let options = []
            let studentResponseCount = 0
            for (let key in optionsHash) {
                if (this.props.multiStepTimeListHash) {
                    let option = optionsHash[key]
                    studentResponseCount += option.usersAnsweredCount
                    options.push(option)
                } else {
                    let option = optionsHash[key]
                    studentResponseCount += option.usersAnsweredCount
                    options.push(option)
                }
            }



            this.videoRef = createRef();

            // console.log(options)

            this.state.studentList = this.props.studentList


            let incorrectUpdated = false, newOptions = [], newIncorrectCount = 0

            if (!questionDetails[0].details.content.type) {
                for (let i = 0; i < options.length; i++) {
                    let opt = options[i]
                    if (opt.isCorrect) {
                        let correctCount = this.props.multiStepTimeListHash['correct'].length
                        opt.usersAnsweredCount = correctCount
                        newOptions.push(opt)
                    }

                    if (!opt.isCorrect && !incorrectUpdated) {
                        opt.usersAnsweredCount = this.props.multiStepTimeListHash['incorrect'].length
                        newOptions.push(opt)
                        incorrectUpdated = true
                    } else if (!incorrectUpdated && !opt.isCorrect && i === options.length - 2) {
                        opt.usersAnsweredCount = this.props.multiStepTimeListHash['incorrect'].length
                        newOptions.push(opt)
                        incorrectUpdated = true
                    } else if (!opt.isCorrect) {
                        opt.usersAnsweredCount = 0
                        newOptions.push(opt)
                    }
                }

                options = newOptions
                studentResponseCount = this.props.multiStepTimeListHash['correct'].length + this.props.multiStepTimeListHash['incorrect'].length
            }


            // console.log(options, questionDetails[0].caseStudySkillHash)

            // console.log(options)

            let playGif = false

            options.forEach(item => {
                let percentage = (item.usersAnsweredCount / studentResponseCount) * 100
                if (percentage >= 50 && item.isCorrect) {
                    playGif = true
                }
            })

            if (playGif) {
                this.playSoundForBarChart()
                // console.log(playGif)
                this.state.playGif = true
            }

            this.state.options = options
            this.state.caseStudySkillHash = questionDetails[0].caseStudySkillHash
            this.state.studentResponseCount = studentResponseCount

            let content = JSON.stringify(this.props.content)
            this.state.content = JSON.parse(content);


            if (window.electron && window.electron.remoteControl) {

                this.handleStartListening()
            }

            if (window.AndroidClicker) {
                // this.setTeacherTimer()
                // this.startScanning()
                this.handleStartListening()
            }

        }

        this.layoutShared = LayoutShared.getLayout()

        if (!this.layoutShared.state.showLayoutBar && !this.props.isReadOnly) {
            this.state.showStudentResponse = false
        }
    }

    componentDidMount() {
        this.resetZoom()

        if (this.props.isReadOnly) {
            console.log('inside read only', this.props.studentList)
            let studentListHash = {}
            this.props.studentList.forEach(item => studentListHash[item.userId] = item)

            this.setState({
                status: `${this.props.userAnswerStatus ? "CORRECT" : "IN_CORRECT"}`,
                studentListHash
            })
            this.getTeacherHomeworkActivity()
            // console.log(this.props.showLeaderboard)
            if (this.props.showLeaderboard) {

                this.generateTimeList()
                this.getQuestionLeaderBoard()
            }
        }

        if (!this.props.isReadOnly) {

            setTimeout(() => {
                this.setState({ showQuestionTimerCountdown: false, isPlaying: true, readOnlyMode: true })
            }, 1000)
            // console.log(this.props.showTimer)
            if (this.props.content.content.images && this.props.content.content.images.length === 1) {
                // this.getMeta(this.props.content.content.images[0].imageUrl, (err, width, height) => {
                //     console.log(width, height);
                // });
                this.loadImage(this.props.content.content.images[0].imageUrl)
            }

            let content = this.getSuffledItem(this.props.content)
            let studentList = this.props.studentList
            let studentClicked = []
            if (this.props.showPreviousQuestion) {
                let questionDetails = this.props.questions.filter(item => item.details._id === this.props.content._id)
                // console.log(questionDetails)
                this.userIdAnswerHash = questionDetails[0].answer.answer
                studentList.forEach(item => {
                    if (this.userIdAnswerHash[item.userId]) {
                        item.receivedAnswer = true
                    }
                })

                studentClicked = Object.keys(this.userIdAnswerHash)
                let optionsHash = questionDetails[0].optionsHash
                let options = []

                for (let key in optionsHash) {
                    if (this.props.multiStepTimeListHash) {
                        let option = optionsHash[key]
                        options.push(option)
                    } else {
                        let option = optionsHash[key]
                        options.push(option)
                    }
                }
                content.content.options = options
            }


            this.setState({ content, studentList, studentClickedCount : studentClicked.length, showTimer: this.props.showPreviousQuestion ? false : this.props.showTimer });
            this.startTimerforAnswer()


            if (window.electron && window.electron.remoteControl) {
                this.handleStartListening()
                setTimeout(() => {
                    this.checkPortOpen()
                }, 10000)
            }
            if (window.AndroidClicker) {
                this.handleStartListening()
            }
            // console.log(content.content.options)
            content.content.options.forEach((item, index) => this.optionsHash[index + 1] = item)
        }
    }

    playSoundForBarChart = () => {
        // this.setState({gifSrc : ''}, () => {
        //     setTimeout(() => this.setState({gifSrc : getImageSource(ImageConstants.CHAPTER_COMPLETED_GIF)}), 100); 
        // })



        this.audioForBarChart.play().catch((error) => {
            console.error("Error playing the sound:", error);
        });
    };

    checkPortOpen() {
        let isPortOpen = window.electron.remoteControl.open();
        // console.log(isPortOpen)
        if (!isPortOpen) {
            // console.log('port not opened opning again')
            this.handleStartListening()
        }
    }


    setTeacherTimer() {
        // console.log('teacher timer Called')
        setTimeout(() => {
            // console.log('teacher timer Called Finished')
            this.setState({ receiveTeacherInput: true })
        }, 5000)
    }


    startScanning = () => {
        if (window.AndroidClicker) {
            // console.log('scanning Started.......')
            window.AndroidClicker.startScanning(); // Calls native Android function
        } else {
            // console.log("AndroidClicker interface not found!");
        }
    };

    stopScanning = () => {
        if (window.AndroidClicker) {
            // console.log('scanning Stoped.......')
            window.AndroidClicker.stopScanning(); // Calls native Android function
        } else {
            // console.log("AndroidClicker interface not found!");
        }
    };




    generateTimeList() {

        // console.log('.....called')

        let timeListHash = { correct: [], incorrect: [], notattempted: [] }

        let questionDetails = this.props.questions.filter(item => item.details._id === this.props.content._id)

        // console.log(questionDetails, this.props.multiStepTimeListHash)

        if (questionDetails[0].answer && questionDetails[0].answer.answer) {
            let userIdAnswerHash = questionDetails[0].answer.answer

            // console.log(userIdAnswerHash)

            if (questionDetails[0].details.content.type) {
                for (let i = 0; i < this.props.studentList.length; i++) {

                    let student = this.props.studentList[i]

                    if (!student.isTeacher) {
                        let answer = userIdAnswerHash[student.userId]

                        if (answer) {
                            // console.log(answer)
                            if (answer.answer.isCorrect) {
                                let timeTakenInMins = (answer.answer.timeTakenToAnswer / 1000).toFixed(3)
                                timeListHash['correct'].push({
                                    userName: student.userName,
                                    userId: student.userId,
                                    studentNumber: student.studentNumber,
                                    timeTakenInMins,
                                    timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                    status: 'CORRECT'
                                })
                            } else {
                                let timeTakenInMins = (answer.answer.timeTakenToAnswer / 1000).toFixed(3)
                                timeListHash['incorrect'].push({
                                    userName: student.userName,
                                    studentNumber: student.studentNumber,
                                    userId: student.userId,
                                    timeTakenInMins,
                                    timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                    status: 'IN_CORRECT'
                                })
                            }
                        } else {
                            timeListHash['notattempted'].push({
                                userName: student.userName,
                                studentNumber: student.studentNumber,
                                userId: student.userId,
                                status: 'NOT_ATTEMPTED'
                            })
                        }
                    }
                }
            } else {
                timeListHash = this.props.multiStepTimeListHash
            }

            // console.log(timeListHash)

            this.setState({ timeListHash, isReload: false }, () => {
                this.setState({ isReload: true })
            })
        } else {
            this.getQuestionLeaderBoard(true)
        }
    }

    getTeacherHomeworkActivity() {
        let payload = {
            homeworkId: this.props.homeworkId
        }

        if (CommonUtils.isOnline()) {
            HomeworkForClickerPracticeApi.getTeacherHomeworkActivity(payload).then(res => {
                // console.log(res)
                let readOnlyStudentList = res.studentList

                this.setState({ readOnlyStudentList, isReadonlyReload: false }, () => {
                    this.setState({ isReadonlyReload: true })
                })

            }).catch(err => {
                // console.log(err)
            })

        } else if (!CommonUtils.isOnline()) {
            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', payload.homeworkId).then((teacherActivityData) => {
                // console.log(teacherActivityData)
                let readOnlyStudentList = teacherActivityData[0].studentList
                this.setState({ readOnlyStudentList, isReadonlyReload: false }, () => {
                    this.setState({ isReadonlyReload: true })
                })
            })
        }
    }

    getQuestionLeaderBoard(value = false) {
        let payload = {
            homeworkId: this.props.homeworkId
        }

        if (CommonUtils.isOnline()) {
            HomeworkForClickerPracticeApi.getHomeworkPracticeQuestionLeaderBoard(payload).then(res => {
                // console.log(res)
                this.setState({ leaderboardData: res.leaderboardBuild }, () => {
                    if (value) {
                        this.setState({ showQuestionLeaderBoard: true })
                    }
                })
            }).catch(err => {
                // console.log(err)
            })
        } else if (!CommonUtils.isOnline()) {

            let homeworkId = this.props.homeworkId

            dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, 'homeworkId', this.props.homeworkId).then(eloActivity => {

                // console.log(eloActivity)

                let teacherUserId = ''

                this.props.studentList.forEach(item => {
                    if (item.isTeacher) {
                        teacherUserId = item.userId
                    }
                })

                let eloActivityHashByUserId = {}
                eloActivity.forEach(activity => {
                    if (!eloActivityHashByUserId[activity.userId] && activity.userId != teacherUserId && activity.isUserPresent && !activity.isFeedback) {
                        eloActivityHashByUserId[activity.userId] = [activity]
                    } else if (activity.userId != teacherUserId && activity.isUserPresent && !activity.isFeedback) {
                        eloActivityHashByUserId[activity.userId].push(activity)
                    }
                })

                // console.log(eloActivityHashByUserId)

                let userIdsList = Object.keys(eloActivityHashByUserId)
                // let userObjectIdList = userIdsList.map(item => ObjectID(item))
                let oneUserActivity = eloActivityHashByUserId[userIdsList[0]]

                let questionIds = []

                for (let i = 0; i < oneUserActivity.length; i++) {

                    let activity = oneUserActivity[i]

                    for (let key in activity.answers) {
                        questionIds.push(key)
                    }
                }


                let usersListHash = {}

                this.props.studentList.forEach(item => usersListHash[item.userId] = item)

                let userActivity = []


                for (let i = 0; i < userIdsList.length; i++) {

                    let activities = eloActivityHashByUserId[userIdsList[i]]

                    let obj = {
                        userId: userIdsList[i]
                    }

                    let questions = {}

                    for (let j = 0; j < activities.length; j++) {

                        let activity = activities[j]

                        for (let key in activity.answers) {
                            // questionIds.push(ObjectID(key))
                            if (!questions[key]) {
                                questions[key] = {
                                    id: key,
                                    ...activity.answers[key],
                                    eloId: activity.eloId,
                                    nodeId: activity.nodeId,
                                    // eloActivityId: activity._id.toString(),
                                    chapter: activity.chapter
                                }
                                // questions[key] = activity.answers[key]
                            }
                        }
                    }
                    obj.questions = questions
                    userActivity.push(obj)
                }


                for (let i = 0; i < userActivity.length; i++) {

                    let questions = userActivity[i].questions
                    let questionsBuild = []

                    for (let j = 0; j < questionIds.length; j++) {

                        let question = questionIds[j].toString()
                        if (questions[question]) {
                            questionsBuild.push({
                                id: question,
                                //details: contentHash[question.id],
                                answer: questions[question] && questions[question].answer ? { id: question, answer: questions[question].answer } : questions[question] && questions[question].steps ? { id: question, steps: questions[question].steps } : null,
                                status: questions[question] && questions[question].status ? questions[question].status : 'NOT_ATTEMPTED',
                                eloId: questions[question].eloId,
                                nodeId: questions[question].nodeId,
                                // eloActivityId: questions[question].eloActivityId,
                                chapter: questions[question].chapter,
                                timeTakenToAnswer: questions[question].timeTakenToAnswer
                            })
                        } else {
                            questionsBuild.push({
                                id: question,
                                //details: contentHash[question.id],
                                answer: null,
                                status: 'NOT_ATTEMPTED',
                                eloId: null,
                                nodeId: null,
                                // eloActivityId: null,
                                chapter: null,
                                userDeviceMacId: null,
                                userId: userActivity[i].userId
                            })
                        }

                        // if (questions[question] && questions[question].steps) {
                        //     multistepQuestionIds.push(ObjectID(question))
                        // }
                    }

                    userActivity[i].questionsBuild = questionsBuild
                }


                let assessmentQuestionWiseStudentInfo = []
                let caseStudyQuestionSkillGrouping = {}, userActivityUpdatePayload = []

                for (let i = 0; i < userActivity.length; i++) {
                    let questionsBuild = userActivity[i].questionsBuild
                    let userData = usersListHash[userActivity[i].userId]

                    let correct = 0;
                    let inCorrect = 0;
                    let notAttempted = 0;
                    let correctQuestionTimeTaken = 0

                    for (let j = 0; j < questionsBuild.length; j++) {
                        let question = questionsBuild[j];

                        if (question.status == 'CORRECT') {
                            correct = correct + 1;

                            if (question.timeTakenToAnswer) {
                                correctQuestionTimeTaken = correctQuestionTimeTaken + question.timeTakenToAnswer
                            }
                        }
                        if (question.status == 'IN_CORRECT') {
                            inCorrect = inCorrect + 1;
                        }

                        if (question.status == 'NOT_ATTEMPTED') {
                            notAttempted = notAttempted + 1;
                        }
                    }



                    let timeTaken = (correctQuestionTimeTaken / 1000).toFixed(3)


                    if (correct) {
                        let updatePayload = {
                            assessmentActivityId: userData.userId + homeworkId,
                            name: userData.userName,
                            userId: userData.userId,
                            transferKey: userData.transferKey,
                            studentNumber: userData.studentNumber,
                            userDeviceMacId: userData.userDeviceMacId,
                            // board: userData.board,
                            // class: userData.class,
                            correctQuestionCount: correct,
                            markScored: correct * 10,
                            incorrectQuestionCount: inCorrect,
                            notAttemptedQuestionCount: notAttempted,
                            countingwellLastUpdateTimestamp: new Date(),
                            timeTaken,
                            timeTakenInMilliSecond: correctQuestionTimeTaken,
                            homeworkId

                        }
                        userActivityUpdatePayload.push(updatePayload)
                    }
                }

                // console.log(userActivityUpdatePayload)

                if (!userActivityUpdatePayload.length) {
                    // console.log(console.log(err))
                    // Responder.sendResponse(StatusCode.SUCCESS, { leaderboardBuild: [] }, res, req);
                    this.setState({ leaderboardData: [] }, () => {
                        if (value) {
                            this.setState({ showQuestionLeaderBoard: true })
                        }
                    })
                    return;
                }

                userActivityUpdatePayload.sort((a, b) => {
                    // Sort by correctQuestionCount in descending order
                    if (a.correctQuestionCount < b.correctQuestionCount) return 1;
                    if (a.correctQuestionCount > b.correctQuestionCount) return -1;

                    // If correctQuestionCount is the same, sort by timeTaken in ascending order
                    if (a.timeTakenInMilliSecond < b.timeTakenInMilliSecond) return -1;
                    if (a.timeTakenInMilliSecond > b.timeTakenInMilliSecond) return 1;

                    return 0; // If both keys are equal
                });

                let activityInfo = userActivityUpdatePayload
                let rank = 0
                let currentCorrectQuestionCount = null
                let currentTimeTaken = null
                let leaderboardBuild = [], leaderboardUpdatePayload = []

                for (let i = 0; i < activityInfo.length; i++) {

                    let activity = activityInfo[i]

                    if (currentCorrectQuestionCount != activity.correctQuestionCount || currentTimeTaken != activity.timeTakenInMilliSecond) {
                        rank += 1
                        currentCorrectQuestionCount = activity.correctQuestionCount
                        currentTimeTaken = activity.timeTakenInMilliSecond
                    }

                    let obj = {
                        ...activity,
                        // countingwellLastUpdateTimestamp: Utils.getISOTime(),
                        rank,
                        type: 'CLICKER_PRACTICE'
                    }

                    // let filterPayload = {
                    //     assessmentActivityId: activity.assessmentActivityId
                    // }

                    // let updatePayload = {
                    //     $set: obj
                    // }

                    leaderboardBuild.push(obj)

                    // leaderboardUpdatePayload.push({ updateOne: { filter: filterPayload, update: updatePayload, upsert: true } })
                }
                dbHelper.updateBulkData(Constants.CLICKER_ASSESSMENT_LEADERBOARD, leaderboardBuild).then(updatedLeaderboardRes => {
                    // console.log('leaderboard updated......')
                    this.setState({ leaderboardData: leaderboardBuild }, () => {
                        if (value) {
                            this.setState({ showQuestionLeaderBoard: true })
                        }
                    })
                })
            }).catch(err => {
                // console.log(err)
            })
        }
    }




    loadImage = (imageUrl) => {
        const img = new Image();
        img.src = imageUrl;

        img.onload = () => {
            // console.log(img.width)
            this.setState({
                imageWidth: img.width,
                imageHeight: img.height
            });
        };
    };


    startTimerforAnswer() {
        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId)
        }
        this.timerIntervalId = setInterval(() => {

            this.answerTickCount += 1
        }, 1000)
    }

    getSuffledItem(content) {
        CommonUtils.shuffleArray(content.content.options);
        return content;
    }

    reset() {
        this.setState({ content: this.getSuffledItem(JSON.parse(JSON.stringify(this.originalContent))) });
    }

    onOptionPressed = (option) => {
        this.isValid = true;
        if (this.props.delegate && this.props.delegate.enableNavigation)
            this.props.delegate.enableNavigation();
    }

    updateAnswer = (payload) => {

        let options = this.props.content.content.options;

        let option = options.filter(opt => opt.id == payload.answer[0].id);
        if (!option.length)
            return;

        option[0].isChecked = true;
        this.isValid = true;
        this.forceUpdate();
    }

    getAnswer = () => {

        // console.log(this.answerTickCount, this.timerIntervalId)

        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId)
        }

        if (this.isValid) {
            // let payload = this.state.studentList;
            // let options = this.state.content.content.options;
            // for (let i = 0; i < options.length; i++) {
            //     // if (options[i].isChecked)
            //         payload.push({ id: options[0].id })
            //     break;
            // }
            return { payload: this.userIdAnswerHash, timeTakenToAnswer: this.answerTickCount, isStudentAnswered: true };
        }
        // else {

        //     let options = this.state.content.content.options;

        //     let incorrectId = '';

        //     for (let i = 0; i < options.length; i++) {
        //         if (!options[i].isCorrect) {
        //             incorrectId = options[i].id
        //             break;
        //         }
        //     }

        //     this.state.studentList.forEach(student => {
        //         if (!student.isTeacher) {
        //             this.userIdAnswerHash[student.userId] = {
        //                 answer: {
        //                     answer: [{ id: incorrectId }],
        //                     id: this.state.content._id,
        //                     userDeviceMacId: student.userDeviceMacId,
        //                     timeTakenToAnswer: 1000000,
        //                     isCorrect: false,
        //                     isFlagged: true // For not answered Question
        //                 }
        //             }
        //         }
        //     })
        //     // return null;
        //     return { payload: this.userIdAnswerHash, timeTakenToAnswer: this.answerTickCount, isStudentAnswered: false };
        // }

    }

    getOptionsInfo = () => {

        let options = this.state.content.content.options;

        let optionsHash = {}

        options.forEach(opt => {
            opt.usersAnsweredCount = 0
            optionsHash[opt.id] = opt
        })

        // console.log(this.userIdAnswerHash)

        for (let key in this.userIdAnswerHash) {

            if (this.userIdAnswerHash[key].answer) {
                let userAnswer = this.userIdAnswerHash[key].answer.answer

                let option = optionsHash[userAnswer[0].id]

                if (!option.usersAnsweredCount) {
                    option.usersAnsweredCount = 1
                } else {
                    option.usersAnsweredCount += 1
                }

                optionsHash[userAnswer[0].id] = option
            }
        }

        return optionsHash
    }


    setHeight = (height) => {
        this.setState({ scrollViewHeight: height });
    }

    onSelectImage = (type) => {
        // this.props.navigation.navigate('Media')
        // this.showMedia(type)
        this.props.delegate && this.props.delegate.showMedia(type)

    }
    showMedia = (type) => {
        this.setState({ showMedia: true, selectedMediaType: type })
    }

    hideMedia = () => {
        this.setState({ showMedia: false })
    }

    addMedia = (url, type) => {
        let attachments = this.state.attachments;
        attachments.push({
            type,
            url
        })

        //console.log('atatch', attachments)
        this.setState({ attachments }, () => {
            this.hideMedia()
            //console.log(this.state.attachments)
        })
    }

    getContentType = (type) => {
        if (type == 'IMAGE') {
            return 'image/jpeg'
        }

        if (type == 'VIDEO') {
            return 'video/mp4'
        }

        if (type == 'AUDIO') {
            return 'audio/mp3'
        }
    }

    renderAttachments = (item, index) => {

        // if (item.type == 'IMAGE') {

        //     return (
        //         <View>
        //             <TouchableOpacity style={styles.attachments} onPress={() => this.openPreview(item.url, 'IMAGE')}>
        //                 <Image source={{ uri: item.url }} style={styles.imageAttachment} resizeMode="cover" />

        //             </TouchableOpacity>
        //             <TouchableOpacity onPress={() => this.removeAttachment(item)} style={styles.deleteIcon} hitSlop={styles.imageHitSlop}><Image source={getImageSource(ImageConstants.DELETE_ATTACHMENT)} /></TouchableOpacity>
        //         </View>

        //     )
        // }

        // if (item.type == 'VIDEO') {

        //     return (
        //         <View>
        //             <TouchableOpacity onPress={() => this.previewAttachment(item)} style={Styles.attachments} onPress={() => this.openPreview(item.url, 'VIDEO')}>
        //                 <Image source={{ uri: item.url }} style={Styles.imageAttachment} resizeMode="contain" />
        //             </TouchableOpacity>
        //             <TouchableOpacity onPress={() => this.removeAttachment(item)} style={Styles.deleteIcon} hitSlop={Styles.imageHitSlop}><Image source={getImageSource(ImageConstants.DELETE_ATTACHMENT)} /></TouchableOpacity>

        //         </View>

        //     )
        // }

        // if (item.type == 'AUDIO') {

        //     return (
        //         <View>
        //             <TouchableOpacity onPress={() => this.previewAttachment(item)} style={Styles.audioAttachment} onPress={() => this.openPreview(item.url, 'AUDIO')}>
        //                 <Image source={getImageSource(ImageConstants.MICROPHONE)} />
        //                 <Image source={getImageSource(ImageConstants.AUDIO_CARD_FOOTER)} style={Styles.audioCardFooter} resizeMode="cover" />
        //                 <TouchableOpacity onPress={() => this.removeAttachment(item)} style={Styles.audioDeleteIcon} hitSlop={Styles.imageHitSlop}><Image source={getImageSource(ImageConstants.NAVIGATION_CLOSE)} /></TouchableOpacity>

        //             </TouchableOpacity>
        //         </View>
        //     )
        // }
    }

    openPreview = (url, type) => {
        this.setState({ previewUrl: url, imagePreview: true, previewType: type })
    }

    closePreview = () => {
        this.setState({ imagePreview: false });
    }

    removeAttachment = (item) => {

        this.props.delegate && this.props.delegate.removeAttachment(item)

    }


    updateAnswerForUserAnswer = (payload) => {

        let content = this.state.content;
        let options = content.content.options;
        // console.log(payload)
        options = options.map(opt => {
            if (opt.id == payload.answer[0].id) {
                opt.isCorrect = true;
            } else {
                opt.isCorrect = false;
            }
            return opt
        });
        content.content.options = options;
        //console.log(content)
        this.setState({ content: content }, () => {

        })
    }

    showMyAnswer = () => {
        if (this.props.userAnswer) {
            this.updateAnswerForUserAnswer(this.props.userAnswer)
        }
    }

    showCorrectAnswer = () => {
        let content = JSON.parse(JSON.stringify(this.props.content))
        //console.log(content)
        this.setState({ content: content }, () => {

        })
    }

    toggleViewAnswer = () => {
        this.setState({ showCorrectAnswer: !this.state.showCorrectAnswer, showSolution: !this.state.showSolution })
    }

    toggleViewSolution = () => {

        if (this.state.status === "CORRECT") {
            return;
        }

        this.setState({ showSolution: !this.state.showSolution, showCorrectAnswer: !this.state.showCorrectAnswer })
    }

    toggleOptions() {
        this.setState({ showOptions: !this.state.showOptions })
    }

    next(event, disableNext) {
        //console.log(disableNext)
        if (this.props.delegate && this.props.delegate.next) {
            // console.log('inside next questions')
            this.props.delegate.next(event);
        }
    }

    previous(event) {
        if (this.props.delegate && this.props.delegate.previous) {
            this.props.delegate.previous(this.props.isReadOnly);
        }
    }


    countdown(seconds) {
        const interval = setInterval(() => {
            if (seconds > 0) {
                // console.log(`${seconds} seconds remaining`);
                seconds--;
            } else {
                // console.log("Time's up!");
                clearInterval(interval);
                this.setState({ stopReceivingStudentSignal: true })
            }
        }, 1000);
    }



    startExtraCountDown() {
        if (!this.props.isReadOnly) {
            this.countdown(1)
        }
    }

    addExtraSeconds() {
        if (!this.state.isReadOnly) {
            this.showToaster('info', "Response Not Accepted Anymore")
            this.playSound();
        }
        this.startExtraCountDown()
    }

    allowKeyPress() {
        this.setState({ allowKey: true })
    }

    playSound = () => {
        this.audio.play().catch((error) => {
            console.error("Error playing the sound:", error);
        });
    };

    toggleLayoutBar() {
        // console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        if (!this.layoutShared.state.showLayoutBar) {
            this.setState({ showStudentResponse: false })
        }

        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }

    zoomInScreen = () => {
        if (window.electron) {
            // console.log('zoom in Called')
            // window.electron.ipcRenderer.send('zoom-in', ['ping'])
            this.scaledCanvasRef.current.zoomIn();
        }

        if (window.AndroidClicker) {
            // console.log('zoom in called')
            // this.setState((prevState) => ({
            //     zoomLevel: Math.min(2, prevState.zoomLevel + 0.1) // max zoom = 200%
            // }));
            if (this.state.zoomLevel < 2) {
                this.setState(prev => ({ zoomLevel: prev.zoomLevel + 0.1 }));
            }
            // window.AndroidClicker.webviewZoomIn() // do whole android webview
        }
    }

    zoomOutScreen = () => {
        if (window.electron) {
            // console.log('zoom out called')
            // window.electron.ipcRenderer.send('zoom-out', ['ping'])
            this.scaledCanvasRef.current.zoomOut();
        }

        if (window.AndroidClicker) {
            // console.log('zoomout called')
            // this.setState((prevState) => ({
            //     zoomLevel: Math.max(0.5, prevState.zoomLevel - 0.1) // min zoom = 50%
            // }));
            if (this.state.zoomLevel > 0.5) {
                this.setState(prev => ({ zoomLevel: prev.zoomLevel - 0.1 }));
            }
            // window.AndroidClicker.webviewZoomOut() // do the whole android webview
        }
    }

    togglePlayPause = () => {
        const video = this.videoRef.current;
        if (video) {
            if (this.state.isVideoPlaying) {
                video.pause();
            } else {
                video.play();
            }
            this.setState((prevState) => ({ isVideoPlaying: !prevState.isVideoPlaying }));
        }
    };

    toggleTimer() {
        // console.log('toggle timer called')

        if (!this.props.isReadOnly && !this.state.showTimer && !this.props.showPreviousQuestion) {
            return;
        }

        const { isPlaying, lastPausedAt, pauseDetails, pauseCount } = this.state;

        if (isPlaying) {
            // Timer is about to be paused
            this.setState({
                lastPausedAt: Date.now(),
                pauseCount: pauseCount + 1, // Increment pause count only when pausing
            });
        } else {
            // Timer is being resumed
            const pausedDuration = Date.now() - lastPausedAt;
            // const pausedDurationInMinutes = (pausedDuration / 1000 / 60).toFixed(2); // Convert to Mins
            const pausedDurationInSeconds = Math.ceil((pausedDuration / 1000).toFixed(2)); // Convert to seconds

            // Store the pause details in an object
            const newPauseDetails = {
                pauseCount: pauseCount, // Don't increment here
                pausedTime: pausedDurationInSeconds,
            };

            this.setState({
                pauseDetails: [...pauseDetails, newPauseDetails], // Add the new pause details to the array
                lastPausedAt: null, // Reset pause timestamp
            }, () => {
                // console.log(this.state.pauseDetails)

                let index = this.state.studentList.findIndex(item => item.isTeacher === true)

                if (index != -1) {
                    this.userIdAnswerHash[this.state.studentList[index].userId] = { pauseDetails: this.state.pauseDetails }
                }
                // console.log(this.userIdAnswerHash)
            });
        }



        this.setState({ isPlaying: !this.state.isPlaying }, () => {
            if (!this.state.isPlaying) {
                // alert('Question Timer Paused')
                this.showToaster('info', "Question Timer Paused")
            }
        });
    };

    // showLeaderboard() {
    //     if (this.state.showQuestionLeaderBoard) {
    //         this.setState({ showQuestionLeaderBoard: false })
    //     } else {
    //         console.log('...........setting leaderboard')
    //         this.setState({ showQuestionLeaderBoard: true })
    //     }
    // }

    resetZoom = () => {

        if (window.electron) {
            // console.log('reset zoom from single select')
            // window.electron.ipcRenderer.send('reset-zoom', ['ping'])
            this.scaledCanvasRef.current.resetZoom();
        }
    }

    handleStartListening = () => {
        const { isListening } = this.state;

        if (window.electron && window.electron.remoteControl) {
            if (isListening) {
                this.setState({ isListening: false });
                window.electron.remoteControl.unsubscribeEvents();
                window.electron.remoteControl.close();
            } else {
                let isPortOpen = window.electron.remoteControl.open();

                // console.log('port open', isPortOpen)

                this.setState({ isListening: true });
                window.electron.remoteControl.subscribeEvents((data) => {
                    console.log('Received data:', data);
                    // console.log(this.state.stopReceivingStudentSignal,
                    //     this.props.isReadOnly, this.state.stopReceivingStudentSignal, this.state.readOnlyFromSingleSelect)

                    let studentList = this.state.studentList

                    let index = studentList.findIndex(item => item.userDeviceMacId === data.payload.id)

                    let key = `${data.payload.id}_${data.payload.value}`
                    const now = Date.now();

                    if (index != -1 && !this.props.isReadOnly) {

                        // console.log(studentList[index])

                        if (studentList[index].isTeacher && data.payload.value === 8) {
                            this.toggleLayoutBar()
                            // window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
                            // this.resetZoom()
                        }

                        if (studentList[index].isTeacher && data.payload.value === 1) {
                            this.next()
                            // if (studentList[index][key]) {
                            //     let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                            //     if (isValid) {
                            //         studentList[index][key].timestamp = now
                            //         this.next()
                            //         // console.log('After 5s Zoom in Called')
                            //     }
                            // } else if (!studentList[index][key]) {
                            //     // console.log('Zoooom In Called......')
                            //     let obj = {
                            //         value: data.payload.value,
                            //         timestamp: now,
                            //         receiveTeacherInput: true
                            //     }
                            //     studentList[index][key] = obj
                            //     this.next()
                            // }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 2) {
                            // this.toggleTimer() // No button to Puase the Timer
                            // this.previous()
                            if (studentList[index][key]) {
                                let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                                if (isValid) {
                                    studentList[index][key].timestamp = now
                                    this.previous()
                                    // console.log('After 5s Zoom in Called')
                                }
                            } else if (!studentList[index][key]) {
                                // console.log('Zoooom In Called......')
                                let obj = {
                                    value: data.payload.value,
                                    timestamp: now,
                                    receiveTeacherInput: true
                                }
                                studentList[index][key] = obj
                                this.previous()
                            }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 4) {

                            if (studentList[index][key]) {
                                let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                                if (isValid) {
                                    studentList[index][key].timestamp = now
                                    this.zoomInScreen()
                                    // console.log('After 5s Zoom in Called')
                                }
                            } else if (!studentList[index][key]) {
                                // console.log('Zoooom In Called......')
                                let obj = {
                                    value: data.payload.value,
                                    timestamp: now,
                                    receiveTeacherInput: true
                                }
                                studentList[index][key] = obj
                                this.zoomInScreen()
                            }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 5) {
                            if (studentList[index][key]) {
                                let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                                if (isValid) {
                                    studentList[index][key].timestamp = now
                                    this.zoomOutScreen()
                                    // console.log('After 5s Zoom out Called')
                                }
                            } else if (!studentList[index][key]) {
                                // console.log('Zoooom out Called......')
                                let obj = {
                                    value: data.payload.value,
                                    timestamp: now,
                                    receiveTeacherInput: true
                                }
                                studentList[index][key] = obj
                                this.zoomOutScreen()
                            }
                        }


                        if (studentList[index].isTeacher && data.payload.value === 3) {
                            this.toggleTimer()
                        }

                        if (studentList[index].isTeacher && data.payload.value === 6) {
                            this.setState({ showStudentResponse: true })
                        }

                        if (studentList[index].isTeacher && data.payload.value === 7) {
                            this.setState({ showStudentResponse: false })
                        }

                        if (!this.state.stopReceivingStudentSignal && !studentList[index].isTeacher
                            && this.state.isPlaying) {
                            this.isValid = true
                            let timeTakenToAnswer = Date.now() - this.state.startTime
                            let option = this.optionsHash[data.payload.value]

                            // console.log(timeTakenToAnswer)

                            if (option && option.id) {
                                studentList[index].receivedAnswer = true
                                studentList[index].isCorrect = option.isCorrect
                                studentList[index].answerId = option.id
                                this.userIdAnswerHash[studentList[index].userId] = {
                                    answer: {
                                        answer: [{ id: option.id }],
                                        id: this.state.content._id,
                                        userDeviceMacId: data.payload.id,
                                        timeTakenToAnswer,
                                        isCorrect: option.isCorrect
                                    }
                                }
                            }
                        }

                        let studentClicked = Object.keys(this.userIdAnswerHash)

                        this.setState({ studentList, studentClickedCount: studentClicked.length })

                    } else if (this.props.isReadOnly) {
                        // console.log(studentList[index])
                        if (studentList[index].isTeacher && data.payload.value === 8) {
                            this.toggleLayoutBar()
                            // window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
                            // this.resetZoom()
                        }



                        if (studentList[index].isTeacher && data.payload.value === 1) {
                            this.next()
                            // if (studentList[index][key]) {
                            //     let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                            //     if (isValid) {
                            //         studentList[index][key].timestamp = now
                            //         this.next()
                            //         console.log('After 1s Next is Called')
                            //     }
                            // } else if (!studentList[index][key]) {
                            //     // console.log('Zoooom In Called......')
                            //     let obj = {
                            //         value: data.payload.value,
                            //         timestamp: now,
                            //         receiveTeacherInput: true
                            //     }
                            //     studentList[index][key] = obj
                            //     this.next()
                            //     console.log('Immediate 1s Next is Called')
                            // }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 2) {
                            // this.previous()
                            if (studentList[index][key]) {
                                let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                                if (isValid) {
                                    studentList[index][key].timestamp = now
                                    this.previous()
                                    // console.log('After 5s Zoom in Called')
                                }
                            } else if (!studentList[index][key]) {
                                // console.log('Zoooom In Called......')
                                let obj = {
                                    value: data.payload.value,
                                    timestamp: now,
                                    receiveTeacherInput: true
                                }
                                studentList[index][key] = obj
                                this.previous()
                            }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 3 && this.state.allowKey) {

                            this.switchTab()

                        } else if (studentList[index].isTeacher && data.payload.value === 3 && this.state.content.content.isFeedback) {
                            this.showOverallLeaderboard()
                        }

                        // if (studentList[index].isTeacher && data.payload.value === 7 && this.state.tabIndex === 7) {
                        //     this.togglePlayPause()
                        // }

                        // if (studentList[index].isTeacher && data.payload.value === 3 && this.state.tabIndex === 4) {
                        //     this.showLeaderboard()
                        // }


                        if (studentList[index].isTeacher && data.payload.value === 4) {

                            if (studentList[index][key]) {
                                let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                                if (isValid) {
                                    studentList[index][key].timestamp = now
                                    this.zoomInScreen()
                                    // console.log('After 5s Zoom in Called')
                                }
                            } else if (!studentList[index][key]) {
                                // console.log('Zoooom In Called......')
                                let obj = {
                                    value: data.payload.value,
                                    timestamp: now,
                                    receiveTeacherInput: true
                                }
                                studentList[index][key] = obj
                                this.zoomInScreen()
                            }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 5) {
                            if (studentList[index][key]) {
                                let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 1
                                if (isValid) {
                                    studentList[index][key].timestamp = now
                                    this.zoomOutScreen()
                                    // console.log('After 5s Zoom out Called')
                                }
                            } else if (!studentList[index][key]) {
                                // console.log('Zoooom out Called......')
                                let obj = {
                                    value: data.payload.value,
                                    timestamp: now,
                                    receiveTeacherInput: true
                                }
                                studentList[index][key] = obj
                                this.zoomOutScreen()
                            }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 6) {
                            this.setState({ showStudentResponse: true })
                        }

                        if (studentList[index].isTeacher && data.payload.value === 7) {
                            this.setState({ showStudentResponse: false })
                        }

                        // if (studentList[index].isTeacher && data.payload.value === 8 && this.state.tabIndex === 3) {
                        //     this.togglePlayPause()
                        // }
                    }

                    // console.log(this.userIdAnswerHash)

                });
            }
            window.electron.ipcRenderer.once('ipc-example', (arg) => {
                // eslint-disable-next-line no-console
                // console.log(arg);
            });
            window.electron.ipcRenderer.send('ipc-example', ['ping']);
        }

        if (window.AndroidClicker) {
            // Set up the global function to receive click events from WebView
            window.onClickEvent = (event) => {
                // console.log("without Clicking Click Event Received:", event);

                // Ensure the event is parsed from JSON if necessary
                let clickData = typeof event === "string" ? JSON.parse(event) : event;

                clickData.value += 1

                // console.log("single select", clickData)

                let studentList = this.state.studentList

                let index = studentList.findIndex(item => item.userDeviceMacId === clickData.id)

                if (index != -1 && !this.props.isReadOnly) {
                    if (studentList[index].isTeacher && clickData.value === 8) {
                        this.toggleLayoutBar()
                        // window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
                        // this.resetZoom()
                    }


                    const now = Date.now();
                    let key = `${clickData.id}_${clickData.value}`

                    if (studentList[index].isTeacher &&
                        studentList[index][key]) {
                        // console.log('with Key')
                        let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 5 // In Seconds

                        if (clickData.value === 1 && isValid) {
                            // console.log('Valid Next')
                            studentList[index][key].timestamp = now
                            this.next()
                        }

                        if (clickData.value === 2 && isValid) {
                            // this.toggleTimer() // No button to Puase the Timer
                            // console.log('Valid previous')
                            studentList[index][key].timestamp = now
                            this.previous()
                        }

                        if (clickData.value === 4 && isValid) {
                            // console.log('Valid zoom in')
                            studentList[index][key].timestamp = now
                            this.zoomInScreen()
                        }

                        if (clickData.value === 5 && isValid) {
                            // console.log('Valid zoom out')
                            studentList[index][key].timestamp = now
                            this.zoomOutScreen()
                        }

                        if (clickData.value === 6) {
                            this.setState({ showStudentResponse: true })
                        }

                        if (clickData.value === 7) {
                            this.setState({ showStudentResponse: false })
                        }

                    } else if (studentList[index].isTeacher &&
                        !studentList[index][key]) {
                        // console.log('no key')

                        let obj = {
                            value: clickData.value,
                            timestamp: now,
                            receiveTeacherInput: true
                        }

                        studentList[index][key] = obj

                        if (clickData.value === 1) {
                            if (this.props.isResume) {
                                this.next()
                            }
                        }

                        if (clickData.value === 2) {
                            // this.toggleTimer() // No button to Puase the Timer
                            this.previous()
                        }

                        if (clickData.value === 4) {
                            this.zoomInScreen()
                        }

                        if (clickData.value === 5) {
                            this.zoomOutScreen()
                        }

                        if (clickData.value === 6) {
                            this.setState({ showStudentResponse: true })
                        }

                        if (clickData.value === 7) {
                            this.setState({ showStudentResponse: false })
                        }

                        if (clickData.value === 8) {
                            this.toggleLayoutBar()
                            // window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
                            // this.resetZoom()
                        }

                    }


                    if (!this.state.stopReceivingStudentSignal && !studentList[index].isTeacher && this.state.isPlaying &&
                        studentList[index].value != clickData.value) {
                        this.isValid = true


                        let timeTakenToAnswer = Date.now() - this.state.startTime
                        let option = this.optionsHash[clickData.value]

                        // console.log(timeTakenToAnswer)

                        if (option && option.id) {
                            studentList[index].receivedAnswer = true
                            studentList[index].value = clickData.value
                            studentList[index].isCorrect = option.isCorrect
                            studentList[index].answerId = option.id
                            this.userIdAnswerHash[studentList[index].userId] = {
                                answer: {
                                    answer: [{ id: option.id }],
                                    id: this.state.content._id,
                                    userDeviceMacId: clickData.id,
                                    timeTakenToAnswer,
                                    isCorrect: option.isCorrect
                                }
                            }
                        }
                    }

                    this.setState({ studentList })

                } else if (this.props.isReadOnly) {
                    // if (studentList[index].isTeacher && clickData.value === 8) {
                    //     this.toggleLayoutBar()
                    //     // window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
                    // }

                    const now = Date.now();


                    let key = `${clickData.id}_${clickData.value}`

                    if (studentList[index].isTeacher &&
                        studentList[index][key]) {
                        // console.log('with Key')
                        let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 5 // In Seconds

                        if (clickData.value === 1 && isValid) {
                            // console.log('Valid')
                            studentList[index][key].timestamp = now
                            this.next()
                        }

                        if (clickData.value === 2 && isValid) {
                            // this.toggleTimer() // No button to Puase the Timer
                            // console.log('Valid previous')
                            studentList[index][key].timestamp = now
                            this.previous()
                        }

                        if (clickData.value === 3 && isValid) {
                            // console.log('Valid Switched Tab')
                            studentList[index][key].timestamp = now
                            this.switchTab()
                        }

                        if (clickData.value === 4 && isValid) {
                            // console.log('Valid zoom in')
                            studentList[index][key].timestamp = now
                            this.zoomInScreen()
                        }

                        if (clickData.value === 5 && isValid) {
                            // console.log('Valid zoom out')
                            studentList[index][key].timestamp = now
                            this.zoomOutScreen()
                        }

                        if (clickData.value === 6) {
                            this.setState({ showStudentResponse: true })
                        }

                        if (clickData.value === 7) {
                            this.setState({ showStudentResponse: false })
                        }

                        if (clickData.value === 8 && this.state.tabIndex === 3 && isValid) {
                            // console.log('Valid video')
                            studentList[index][key].timestamp = now
                            this.togglePlayPause()
                        }
                    } else if (studentList[index].isTeacher &&
                        !studentList[index][key]) {
                        // console.log('no key')

                        let obj = {
                            value: clickData.value,
                            timestamp: now,
                            receiveTeacherInput: true
                        }

                        studentList[index][key] = obj

                        if (clickData.value === 1) {
                            if (this.props.isResume) {
                                this.next()
                            }
                        }

                        if (clickData.value === 2) {
                            // this.toggleTimer() // No button to Puase the Timer
                            this.previous()
                        }

                        if (clickData.value === 3) {
                            this.switchTab()
                        }

                        if (clickData.value === 4) {
                            this.zoomInScreen()
                        }

                        if (clickData.value === 5) {
                            this.zoomOutScreen()
                        }


                        if (clickData.value === 6) {
                            this.setState({ showStudentResponse: true })
                        }

                        if (clickData.value === 7) {
                            this.setState({ showStudentResponse: false })
                        }

                        if (clickData.value === 8 && this.state.tabIndex === 3) {
                            this.togglePlayPause()
                        }
                    }

                    // if (studentList[index].isTeacher && clickData.value === 2) {
                    //     this.previous()
                    // }



                    // if (studentList[index].isTeacher && clickData.value === 7 && this.state.tabIndex === 7) {
                    //     this.togglePlayPause()
                    // }

                    // if (studentList[index].isTeacher && clickData.value === 3 && this.state.tabIndex === 4) {
                    //     this.showLeaderboard()
                    // }


                    // if (studentList[index].isTeacher && clickData.value === 4) {
                    //     this.zoomInScreen()
                    // }

                    // if (studentList[index].isTeacher && clickData.value === 5) {
                    //     this.zoomOutScreen()
                    // }

                    // if (studentList[index].isTeacher && clickData.value === 6) {
                    //     this.setState({ showStudentResponse: !this.state.showStudentResponse })
                    // }
                }

                // console.log(this.userIdAnswerHash)
            };
        }
    };

    componentWillUnmount() {
        // Cleanup on component unmount
        if (window.electron && window.electron.remoteControl) {
            window.electron.remoteControl.unsubscribeEvents();
            let value = window.electron.remoteControl.close();
            // console.log('port closed', value)
        }

        // if (window.AndroidClicker) {
        //     this.stopScanning()
        // }

    }

    toggleStudentResponse() {
        this.setState({ showStudentResponse: !this.state.showStudentResponse })
    }

    switchTab(index) {

        if (index) {
            this.setState({ tabIndex: index, restartKey: this.state.restartKey + 1, allowKey: false })
            return
        } else {
            this.setState({ restartKey: this.state.restartKey + 1, allowKey: false })
        }

        let showSolutionTab = this.checkSolutionContentExist()


        if (this.props.showLeaderboard) {
            if (this.props.content.videoUrl) {
                if (this.state.tabIndex === 1) {
                    this.setState({ tabIndex: 2 })
                } else if (this.state.tabIndex === 2) {
                    this.setState({ tabIndex: 3 })
                } else if (this.state.tabIndex === 3) {
                    this.setState({ tabIndex: 4 })
                } else if (this.state.tabIndex === 4) {
                    this.setState({ tabIndex: 5 })
                } else if (this.state.tabIndex === 5) {
                    this.setState({ tabIndex: 1 })
                }

            } else {

                if (this.state.tabIndex === 1) {
                    this.setState({ tabIndex: 2 })
                } else if (this.state.tabIndex === 2) {
                    this.setState({ tabIndex: 4 })
                } else if (this.state.tabIndex === 4) {
                    this.setState({ tabIndex: 5 })
                } else if (this.state.tabIndex === 5) {
                    this.setState({ tabIndex: 1 })
                }

            }
        } else {
            if (this.props.content.videoUrl) {
                if (this.state.tabIndex === 1) {
                    this.setState({ tabIndex: 2 })
                } else if (this.state.tabIndex === 2) {
                    this.setState({ tabIndex: 3 })
                } else if (this.state.tabIndex === 3) {
                    this.setState({ tabIndex: 1 })
                }
            } else {
                if (this.state.tabIndex === 1) {
                    this.setState({ tabIndex: 2 })
                } else if (this.state.tabIndex === 2) {
                    this.setState({ tabIndex: 1 })
                }
            }
        }
    }

    getTimer() {
        return (
            <div className="col-1">
                <div className='timer-wrapper'>
                    <div className=''>
                        <CountdownCircleTimer
                            key={this.state.restartKey}
                            size={40}
                            trailColor='#1CEA24'
                            isPlaying={true}
                            duration={5}
                            colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                            colorsTime={[10, 6, 3, 0]}
                            onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.allowKeyPress())}
                        >
                            {/* {(remainingTime) => (
                                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                                        <div className="timer-text">
                                                            {this.children(remainingTime)}
                                                        </div>
                                                    </div>
                                                )} */}
                        </CountdownCircleTimer>
                    </div>
                </div>
            </div>
        )
    }


    checkSolutionContentExist() {
        const html = this.props.content.content.solutionSteps?.summarySolution;
        const text = html.replace(/<[^>]*>/g, '');
        let showSolutionTab = true
        if (`${text}` === 'No Solution' || !text) {
            showSolutionTab = false
        }
        return showSolutionTab
    }


    showTabs() {

        this.theme = SharedThemeCategory.getThemeCategory(this.props.categoryThemeId)

        this.theme['themeColor'] = '#0B7077'

        let showSolutionTab = this.checkSolutionContentExist()

        return (
            <div className="answer-tab-for-practice-flow">
                <div className={`row row-max-width-for-answer justify-content-center align-items-center mr-0 ml-0 mt-3 mb-3`}>
                    {
                        <div className="col d-flex pl-0">
                            <div className={`text-center row answer-status-text p-2 tab  
                            ${this.state.tabIndex == 1 ? 'active-tab' : 'in-active-tab'}`}
                                style={{ backgroundColor: this.state.tabIndex == 1 ? this.theme['themeColor'] : '' }} onClick={() => { this.switchTab(1) }}>
                                <div className="tab-text col">{"Response"}</div>
                                {
                                    this.state.tabIndex == 1 ? this.getTimer() : <></>
                                }
                            </div>

                            {
                                this.props.content.videoUrl ?
                                    <>
                                        <div className={`text-center row answer-status-text p-2 tab no-border-radius ${this.state.tabIndex == 2 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                            style={{ backgroundColor: this.state.tabIndex == 2 ? this.theme['themeColor'] : '' }}
                                            onClick={() => { this.switchTab(2) }}>
                                            <div className="tab-text col">{showSolutionTab ? "Solution" : 'Question'}</div>
                                            {
                                                this.state.tabIndex == 2 ? this.getTimer() : <></>
                                            }
                                        </div>
                                        {
                                            this.props.showLeaderboard ?
                                                <>
                                                    <div className={`text-center row answer-status-text p-2 tab no-border-radius ${this.state.tabIndex == 3 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 3 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(3) }}>
                                                        <div className="tab-text col">{"Video"}</div>
                                                        {
                                                            this.state.tabIndex == 3 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                    <div className={`text-center row answer-status-text p-2 tab no-border-radius ${this.state.tabIndex == 4 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 4 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(4) }}>
                                                        <div className="tab-text col">{"Question Rank"}</div>
                                                        {
                                                            this.state.tabIndex == 4 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                    <div className={`text-center row answer-status-text p-2 tab border-left ${this.state.tabIndex == 5 ? 'active-solution-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 5 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(5) }}>
                                                        <div className="tab-text col">{"Overall Rank"}</div>
                                                        {
                                                            this.state.tabIndex == 5 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className={`text-center row answer-status-text p-2 tab border-left ${this.state.tabIndex == 3 ? 'active-solution-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 3 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(3) }}>
                                                        <div className="tab-text col">{"Video"}</div>
                                                        {
                                                            this.state.tabIndex == 3 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                </>
                                        }

                                    </>
                                    :
                                    <>
                                        {
                                            this.props.showLeaderboard ?
                                                <>
                                                    {/* {
                                                        showSolutionTab ? */}
                                                    <div className={`text-center row answer-status-text p-2 tab no-border-radius ${this.state.tabIndex == 2 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 2 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(2) }}>
                                                        <div className="tab-text col">{showSolutionTab ? "Solution" : 'Question'}</div>
                                                        {
                                                            this.state.tabIndex == 2 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                    {/* :
                                                            <></>
                                                    } */}
                                                    <div className={`text-center row answer-status-text p-2 tab no-border-radius ${this.state.tabIndex == 4 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 4 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(4) }}>
                                                        <div className="tab-text col">{"Question Rank"}</div>
                                                        {
                                                            this.state.tabIndex == 4 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                    <div className={`text-center row answer-status-text p-2 tab border-left ${this.state.tabIndex == 5 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                                        style={{ backgroundColor: this.state.tabIndex == 5 ? this.theme['themeColor'] : '' }}
                                                        onClick={() => { this.switchTab(5) }}>
                                                        <div className="tab-text col">{"Overall Rank"}</div>
                                                        {
                                                            this.state.tabIndex == 5 ? this.getTimer() : <></>
                                                        }
                                                    </div>
                                                </>
                                                :
                                                // showSolutionTab ?
                                                <div className={`text-center row answer-status-text p-2 tab border-left ${this.state.tabIndex == 2 ? 'active-my-answer-tab' : 'in-active-tab'}`}
                                                    style={{ backgroundColor: this.state.tabIndex == 2 ? this.theme['themeColor'] : '' }}
                                                    onClick={() => { this.switchTab(2) }}>
                                                    <div className="tab-text col">{showSolutionTab ? "Solution" : 'Question'}</div>
                                                    {
                                                        this.state.tabIndex == 2 ? this.getTimer() : <></>
                                                    }
                                                </div>
                                            // :
                                            // <></>
                                        }
                                    </>
                            }
                        </div>

                    }

                </div>
            </div>
        )
    }

    children = ({ remainingTime }) => {
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60

        return `${minutes}:${seconds}`
    }


    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    getMultiStepStemQuestion() {

        let questionDetails = this.props.questions.filter(item => item.details._id === this.props.content._id)

        let content = questionDetails[0].details

        if (content.content.images.length === 1 && this.state.imageWidth < 1010 && !content.content.displayQuestionImageAtBottom) {
            return (
                <div className="d-flex align-items-start">
                    <QuestionTitle title={content.content.title}
                        queNo={this.props.quesNo ? this.props.quesNo : null}
                        noOfDots={this.props.totalSteps}
                        activeDot={this.props.quesNo}
                        hideBackground={this.props.isMultiStep ? true : false}
                        categoryThemeId={this.props.categoryThemeId}
                        isAssessment={this.props.isAssessment}
                        delegate={this.props.delegate}
                        isReadOnly={this.props.isReadOnly}
                        showOptions={this.state.showOptions}
                        toggleOptions={() => this.toggleOptions()}
                        questions={this.props.questions}
                        activePage={this.props.activePage}
                        isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                        showStudentResponse={this.state.showStudentResponse}
                        singleSelectDelegate={this}
                        isPlaying={this.state.isPlaying}
                        questionTime={this.props.isReadOnly ? 0 : 60}
                        questionImageExist={content.content.images && content.content.images.length ? true : false}
                        questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                        showLargeStudentResponseSideBar={this.props.showLargeStudentResponseSideBar}
                        isSchoolAssignment={true}
                        isFFF={true}
                    />
                    {
                        content.content.images.length ?
                            <div className="d-flex mt-2">
                                {
                                    <div className="question-image-wrapper d-flex">
                                        {
                                            content.content.images.map(image => (
                                                <div className=" "
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? '0rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`

                                                    }}>
                                                    <img className="question-image-size" style={{ maxWidth: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? "none" : ''}` }}
                                                        src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                </div>
                                            ))
                                        }
                                    </div>
                                }
                                <div><img className='expand-icon ml-1 mr-3 cursor-pointer' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img></div>
                            </div>
                            :
                            <></>
                    }

                </div>
            )
        } else {
            return (
                <>
                    <QuestionTitle title={content.content.title}
                        queNo={this.props.quesNo ? this.props.quesNo : null}
                        noOfDots={this.props.totalSteps}
                        activeDot={this.props.quesNo}
                        hideBackground={this.props.isMultiStep ? true : false}
                        categoryThemeId={this.props.categoryThemeId}
                        isAssessment={this.props.isAssessment}
                        delegate={this.props.delegate}
                        isReadOnly={this.props.isReadOnly}
                        // isSchoolAssignment={true}

                        showOptions={this.state.showOptions}
                        toggleOptions={() => this.toggleOptions()}
                        questions={this.props.questions}
                        totalQuestions={this.props.totalQuestions}
                        activePage={this.props.activePage}
                        isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                        showStudentResponse={this.state.showStudentResponse}
                        singleSelectDelegate={this}
                        isPlaying={this.state.isPlaying}
                        questionTime={this.props.isReadOnly ? 0 : 60}
                        questionImageExist={content.content.images && content.content.images.length ? true : false}
                        questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                        isFFF={true}
                        showPreviousQuestion={this.props.showPreviousQuestion}
                    />
                    {
                        content.content.images.length ?
                            <div className="d-flex mt-2">
                                {
                                    <div className="question-image-wrapper d-flex">
                                        {
                                            content.content.images.map(image => (
                                                <div className=" "
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? this.props.showLargeStudentResponseSideBar ? "20rem" : '14rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                    }}>
                                                    <img className="question-image-size-for-bottom-image" src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                </div>
                                            ))
                                        }
                                    </div>

                                }

                                <div><img className='expand-icon ml-1 mr-3 cursor-pointer' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img></div>
                            </div>
                            : <></>
                    }

                </>
            )
        }
    }


    getMultiStepQuestion(content) {
        if (content.content.images.length === 1 && this.state.imageWidth < 1010 && !content.content.displayQuestionImageAtBottom) {
            return (
                <div className="d-flex align-items-start">
                    <QuestionTitle title={content.content.title}
                        queNo={this.props.quesNo ? this.props.quesNo : null}
                        noOfDots={this.props.totalSteps}
                        activeDot={this.props.quesNo}
                        hideBackground={this.props.isMultiStep ? true : false}
                        categoryThemeId={this.props.categoryThemeId}
                        isAssessment={this.props.isAssessment}
                        delegate={this.props.delegate}
                        isReadOnly={this.props.isReadOnly}
                        showOptions={this.state.showOptions}
                        toggleOptions={() => this.toggleOptions()}
                        questions={this.props.questions}
                        activePage={this.props.activePage}
                        isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                        showStudentResponse={this.state.showStudentResponse}
                        singleSelectDelegate={this}
                        isPlaying={this.state.isPlaying}
                        questionTime={this.props.isReadOnly ? 0 : 60}
                        questionImageExist={content.content.images && content.content.images.length ? true : false}
                        questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                        showLargeStudentResponseSideBar={this.props.showLargeStudentResponseSideBar}
                        isSchoolAssignment={true}
                        isFFF={true}
                    />
                    {
                        content.content.images.length ?
                            <div className="d-flex mt-2">
                                {
                                    <div className="question-image-wrapper d-flex">
                                        {
                                            content.content.images.map(image => (
                                                <div className=" "
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? '0rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`

                                                    }}>
                                                    <img className="question-image-size" style={{ maxWidth: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? "none" : ''}` }}
                                                        src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                </div>
                                            ))
                                        }
                                    </div>
                                }
                            </div>
                            :
                            <></>
                    }
                    {
                        this.props.isReadOnly && this.state.showOptions ?
                            <div className={`mt-3 option-margin-bottom-new`}>
                                <RadioGroup options={content.content.options}
                                    // onOptionPressed={this.onOptionPressed}
                                    isCheckPoint={this.props.isCheckPoint}
                                    // isReadOnly={this.props.isReadOnly}
                                    categoryThemeId={this.props.categoryThemeId}
                                    classText={this.props.classText}
                                />
                            </div>
                            :
                            <></>
                    }
                </div>
            )
        } else {
            return (
                <>
                    <QuestionTitle title={content.content.title}
                        queNo={this.props.quesNo ? this.props.quesNo : null}
                        noOfDots={this.props.totalSteps}
                        activeDot={this.props.quesNo}
                        hideBackground={this.props.isMultiStep ? true : false}
                        categoryThemeId={this.props.categoryThemeId}
                        isAssessment={this.props.isAssessment}
                        delegate={this.props.delegate}
                        isReadOnly={this.props.isReadOnly}
                        isSchoolAssignment={true}

                        showOptions={this.state.showOptions}
                        toggleOptions={() => this.toggleOptions()}
                        questions={this.props.questions}
                        totalQuestions={this.props.totalQuestions}
                        activePage={this.props.activePage}
                        isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                        showStudentResponse={this.state.showStudentResponse}
                        singleSelectDelegate={this}
                        isPlaying={this.state.isPlaying}
                        questionTime={this.props.isReadOnly ? 0 : 60}
                        questionImageExist={content.content.images && content.content.images.length ? true : false}
                        questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                        isFFF={true}
                    />
                    {
                        content.content.images.length ?
                            <div className="d-flex mt-2">
                                {
                                    <div className="question-image-wrapper d-flex">
                                        {
                                            content.content.images.map(image => (
                                                <div className=" "
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? this.props.showLargeStudentResponseSideBar ? "20rem" : '14rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                    }}>
                                                    <img className="question-image-size-for-bottom-image" src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                </div>
                                            ))
                                        }
                                    </div>

                                }

                                {/* <div><img className='expand-icon ml-1 mr-3 cursor-pointer' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img></div> */}
                            </div>
                            : <></>
                    }
                    {
                        this.props.isReadOnly && this.state.showOptions ?
                            <div className={`mt-3 option-margin-bottom-new`}>
                                <RadioGroup options={content.content.options}
                                    // onOptionPressed={this.onOptionPressed}
                                    isCheckPoint={this.props.isCheckPoint}
                                    // isReadOnly={this.props.isReadOnly}
                                    categoryThemeId={this.props.categoryThemeId}
                                    classText={this.props.classText}
                                />
                            </div>
                            :
                            <></>
                    }
                </>
            )
        }
    }


    goToPracticeList() {
        // console.log('clicked')

        if (this.props.isReadOnly) {
            this.props.mainDelegate && this.props.mainDelegate.goToPracticeList && this.props.mainDelegate.goToPracticeList()
        } else {
            this.props.delegate && this.props.delegate.goToPracticeList && this.props.delegate.goToPracticeList()
        }
    }

    showOverallLeaderboard() {
        this.setState({ viewOverallLeaderboard: !this.state.viewOverallLeaderboard })
    }


    assessmentFooter(content) {
        // console.log(this.props.isReadOnly)
        return (
            <>
                {
                    !this.props.isReadOnly && this.state.showQuestionTimerCountdown ? <></> :
                        <>
                            <div>
                                {
                                    !this.state.showStudentResponse && !this.layoutShared.state.showLayoutBar ?
                                        <div className='student-response-toggle-button d-flex align-items-center justify-content-center cursor-pointer'
                                            onClick={() => this.toggleStudentResponse()}>
                                            <img className='arrow-image-size' src={getImageSource(!this.state.showStudentResponse ? ImageConstants.ANGLE_UP_ARROW : ImageConstants.ANGLE_DOWN_ARROW)} />
                                        </div>
                                        :
                                        <div className='student-response-toggle-button-for-close d-flex align-items-center justify-content-center cursor-pointer'
                                            onClick={() => this.toggleStudentResponse()}>
                                            <img className='arrow-image-size' src={getImageSource(!this.state.showStudentResponse ? ImageConstants.ANGLE_UP_ARROW : ImageConstants.ANGLE_DOWN_ARROW)} />
                                        </div>
                                }


                                <div className="student-answered-board"
                                    style={{
                                        bottom: `${!this.layoutShared.state.showLayoutBar ? '1rem' : '1rem'}`,
                                        display: `${this.state.showStudentResponse ? 'block' : 'none'}`
                                    }}>
                                    {
                                        this.state.isReadonlyReload ?
                                            <>
                                                <StudentAnsweredStatusBoard studentList={this.props.isReadOnly ? this.state.readOnlyStudentList : this.state.studentList}
                                                    isPlaying={this.state.isPlaying}
                                                    showTimer={this.state.showTimer}
                                                    isReadOnly={this.props.isReadOnly}
                                                    // questionTime={this.props.isReadOnly ? 0 : this.props.showPreviousQuestion ? 0 : 1000}
                                                    questionTime={this.props.isReadOnly ? 0 : content?.content.duration ? content.content.duration * 60 : this.props.isMultiStep ? this.props.mulipStepQuestion.content.duration ? this.props.mulipStepQuestion.content.duration * 60 : 60 : 60}
                                                    delegate={this}
                                                    isFullScreenMode={!this.layoutShared.state.showLayoutBar} />
                                            </>
                                            :
                                            <>
                                            </>
                                    }

                                    {

                                        !this.props.isReadOnly ?
                                            <StudentAnsweredStatusBoard studentList={this.props.isReadOnly ? this.state.readOnlyStudentList : this.state.studentList}
                                                isPlaying={this.state.isPlaying}
                                                showTimer={this.state.showTimer}
                                                isReadOnly={this.props.isReadOnly}
                                                // questionTime={this.props.isReadOnly ? 0 : this.props.showPreviousQuestion ? 0 : 1000}
                                                questionTime={this.props.isReadOnly ? 0 : content?.content.duration ? content.content.duration * 60 : this.props.isMultiStep ? this.props.mulipStepQuestion.content.duration ? this.props.mulipStepQuestion.content.duration * 60 : 60 : 60}
                                                delegate={this}
                                                isFullScreenMode={!this.layoutShared.state.showLayoutBar} />
                                            :
                                            <></>

                                    }
                                </div>
                            </div>
                            {
                                this.state.stopReceivingStudentSignal && this.state.showTimer ?
                                    <div className="">
                                        {/* {!this.props.isCheckPoint && !this.props.isMultiStep && <AssessmentFooter userAnswerStatus={this.props.userAnswerStatus} isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer} isReadOnly={this.props.isReadOnly} delegate={this.props.delegate} categoryThemeId={this.props.categoryThemeId}></AssessmentFooter>} */}
                                        {!this.props.isCheckPoint && <AssessmentFooter
                                            userAnswerStatus={this.props.userAnswerStatus}
                                            isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer}
                                            isReadOnly={this.props.isReadOnly}
                                            delegate={this.props.delegate}
                                            categoryThemeId={this.props.categoryThemeId}
                                            showStudentResponse={this.state.showStudentResponse}
                                            showNextIcon={true}>
                                        </AssessmentFooter>}
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                !this.state.stopReceivingStudentSignal && !this.props.isReadOnly && !this.state.showStudentResponse ?
                                    <div className="">
                                        {/* {!this.props.isCheckPoint && !this.props.isMultiStep && <AssessmentFooter userAnswerStatus={this.props.userAnswerStatus} isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer} isReadOnly={this.props.isReadOnly} delegate={this.props.delegate} categoryThemeId={this.props.categoryThemeId}></AssessmentFooter>} */}
                                        {!this.props.isCheckPoint && <AssessmentFooter
                                            studentClickedCount={this.state.studentClickedCount}
                                            userAnswerStatus={this.props.userAnswerStatus}
                                            isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer}
                                            isReadOnly={this.props.isReadOnly}
                                            delegate={this.props.delegate}
                                            categoryThemeId={this.props.categoryThemeId}
                                            showStudentResponse={this.state.showStudentResponse}
                                            showNextIcon={false}></AssessmentFooter>}
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                !this.state.showTimer ?
                                    <div className="">
                                        {/* {!this.props.isCheckPoint && !this.props.isMultiStep && <AssessmentFooter userAnswerStatus={this.props.userAnswerStatus} isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer} isReadOnly={this.props.isReadOnly} delegate={this.props.delegate} categoryThemeId={this.props.categoryThemeId}></AssessmentFooter>} */}
                                        {!this.props.isCheckPoint && <AssessmentFooter
                                            studentClickedCount={this.state.studentClickedCount}
                                            userAnswerStatus={this.props.userAnswerStatus}
                                            isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer}
                                            isReadOnly={this.props.isReadOnly}
                                            delegate={this.props.delegate}
                                            categoryThemeId={this.props.categoryThemeId}
                                            showStudentResponse={this.state.showStudentResponse}
                                            showNextIcon={true}></AssessmentFooter>}
                                    </div>
                                    :
                                    <></>
                            }

                            {
                                this.props.isReadOnly ?
                                    <div className="">
                                        {<AssessmentFooter
                                            singleSelectDelegate={this}
                                            isFFF={this.props.isFFF}
                                            userAnswerStatus={this.props.userAnswerStatus}
                                            isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer}
                                            isReadOnly={this.props.isReadOnly}
                                            delegate={this.props.delegate}
                                            categoryThemeId={this.props.categoryThemeId}
                                            showStudentResponse={this.state.showStudentResponse}
                                            showNextIcon={true}></AssessmentFooter>}
                                    </div>
                                    :
                                    <></>
                            }
                            {
                                !this.props.isReadOnly && this.state.showTimer && !this.props.showPreviousQuestion ?
                                    <div className={`timer-wrapper-in-question-screen ${this.state.showStudentResponse ? 'timer-placement-when-student-response-showed' : ''}`}
                                        style={{ display: (this.state.stopReceivingStudentSignal) ? "none" : "flex" }}>
                                        <div className=''>
                                            <CountdownCircleTimer
                                                size={100}
                                                trailColor='#CAEAEC'
                                                isPlaying={this.state.isPlaying}
                                                // duration={1000}
                                                duration={this.props.isReadOnly ? 0 : content?.content.duration ? content.content.duration * 60 : this.props.isMultiStep ? this.props.mulipStepQuestion.content.duration ? this.props.mulipStepQuestion.content.duration * 60 : 60 : 60}
                                                // duration={this.props.isReadOnly ? 0 : content.content.duration ? content.content.duration * 60 : 5}
                                                colors={["#0B7077", "#F7B801", "#A30000", "#A30000"]}
                                                colorsTime={[10, 6, 3, 0]}
                                                onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.addExtraSeconds())}
                                            >
                                                {(remainingTime) => (
                                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                                        <div className="timer-text">
                                                            {this.children(remainingTime)}
                                                        </div>
                                                        {
                                                            !this.state.isPlaying ?
                                                                <div className="">
                                                                    <img className="pause-button-image-size" src={getImageSource(ImageConstants.PAUSE_BUTTON)} />
                                                                </div>
                                                                :
                                                                <></>
                                                        }
                                                    </div>
                                                )}
                                            </CountdownCircleTimer>
                                        </div>
                                    </div>
                                    :
                                    <></>

                            }
                        </>
                }

            </>
        )
    }


    render() {

        // setCategoryThemeStyles(this.props.categoryThemeId);

        let content = this.state.content;
        // console.log(content)
        // console.log(this.state.studentList)
        // console.log(this.state.imageWidth)
        // if (this.state.showMedia)
        // return <View style={{ flex: 1 }}><Media delegate={this} type={this.state.selectedMediaType} /></View>

        this.theme = SharedThemeCategory.getThemeCategory(this.props.categoryThemeId)

        let showSolution = this.checkSolutionContentExist()

        return (

            <ScaledCanvas ref={this.scaledCanvasRef}
                footer={this.assessmentFooter(content)}
                isReadOnly={this.props.isReadOnly}
                showQuestionTimerCountdown={this.state.showQuestionTimerCountdown}>
                {(finalScale) => (content ?

                    !this.props.isReadOnly && this.state.showQuestionTimerCountdown && !this.props.showPreviousQuestion ?
                        <div style={{
                            width: 1920,
                            height: 1080
                        }}>
                            <img className="question-countdown-image" src={getImageSource(ImageConstants.QUESTION_COUNT_DOWN)} />
                        </div>
                        :
                        <div style={{}}>
                            <div className="single-select-for-practice-flow-new-v3 position-relative"
                                style={{
                                    width: 1920,
                                    height: "auto",      // 🔥 important
                                    // minHeight: 1080
                                }}
                                // style={{
                                //     transform: window.AndroidClicker ? `scale(${this.state.zoomLevel})` : null,
                                //     transformOrigin: 'top left',
                                //     transition: 'transform 0.2s ease',
                                //     width: window.AndroidClicker ? `${1920 / this.state.zoomLevel}px` : "auto",
                                //     height: window.AndroidClicker ? `${1080 / this.state.zoomLevel}px` : 'auto',
                                // }}
                                onMouseEnter={ReactTooltip.rebuild}>
                                {/* <div className={`${!this.props.isReadOnly ? "min-height" : ""}`}> */}
                                {/* {
                                    !this.state.showStudentResponse && !this.layoutShared.state.showLayoutBar ?
                                        <div className='student-response-toggle-button d-flex align-items-center justify-content-center cursor-pointer'
                                            onClick={() => this.toggleStudentResponse()}>
                                            <img className='arrow-image-size' src={getImageSource(!this.state.showStudentResponse ? ImageConstants.BLUE_RIGHT_ICON : ImageConstants.BLUE_LEFT_ICON)} />
                                        </div>
                                        :
                                        <div className='student-response-toggle-button-for-close d-flex align-items-center justify-content-center cursor-pointer'
                                            onClick={() => this.toggleStudentResponse()}>
                                            <img className='arrow-image-size' src={getImageSource(!this.state.showStudentResponse ? ImageConstants.BLUE_RIGHT_ICON : ImageConstants.BLUE_LEFT_ICON)} />
                                        </div>
                                } */}



                                {
                                    this.state.showTimer ?
                                        <>
                                            {
                                                !this.state.isPlaying ?
                                                    <div className="d-flex justify-content-center"><img className="blur-image-size" src={getImageSource(ImageConstants.TIMER_PAUSED)} /></div>
                                                    :
                                                    this.state.stopReceivingStudentSignal ?
                                                        <div className="d-flex justify-content-center"><img className="blur-image-size" src={getImageSource(ImageConstants.QUESTION_BLUR)} /></div>
                                                        :
                                                        <></>

                                            }
                                        </>
                                        :
                                        <></>
                                }

                                {
                                    this.props.showPreviousQuestion ?
                                        <div className="d-flex justify-content-center"><img className="previous-blur-image-size" src={getImageSource(ImageConstants.TRANSPARENT_IMAGE)} /></div>
                                        :
                                        <></>
                                }

                                <div className={`${"min-height"}`}>
                                    {
                                        !this.props.isCheckPoint && this.props.isMultiStep && !this.props.isReadOnly ?
                                            <>
                                                {this.getMultiStepStemQuestion()}

                                                {this.getMultiStepQuestion(content)}
                                            </>
                                            :
                                            !this.props.isMultiStep && !this.props.isCheckPoint && !this.props.isReadOnly && content.content.images.length === 1 && this.state.imageWidth < 1010 && !content.content.displayQuestionImageAtBottom ?
                                                <div className="question-container">
                                                    {
                                                        content.content.images.length ?
                                                            <div className="question-image-wrapper">
                                                                {
                                                                    <div className="d-flex">
                                                                        {
                                                                            content.content.images.map(image => (
                                                                                <div className="d-flex align-item-start"
                                                                                    style={{
                                                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? '0rem' :
                                                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`

                                                                                    }}>
                                                                                    <img className="question-image-size" style={{ maxWidth: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? "none" : ''}` }}
                                                                                        src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                                                    <div className="expand-icon-wrapper">
                                                                                        <img className='expand-icon ml-1 mr-3 cursor-pointer ' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                            : <></>
                                                    }
                                                    <div className="question-text">
                                                        <QuestionTitle title={content.content.title}
                                                            queNo={this.props.quesNo ? this.props.quesNo : null}
                                                            noOfDots={this.props.totalSteps}
                                                            activeDot={this.props.quesNo}
                                                            hideBackground={this.props.isMultiStep ? true : false}
                                                            categoryThemeId={this.props.categoryThemeId}
                                                            isAssessment={this.props.isAssessment}
                                                            delegate={this.props.delegate}
                                                            isReadOnly={this.props.isReadOnly}
                                                            showOptions={this.state.showOptions}
                                                            toggleOptions={() => this.toggleOptions()}
                                                            questions={this.props.questions}
                                                            totalQuestions={this.props.totalQuestions}
                                                            activePage={this.props.activePage}
                                                            isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                            showStudentResponse={this.state.showStudentResponse}
                                                            singleSelectDelegate={this}
                                                            isPlaying={this.state.isPlaying}
                                                            questionTime={this.props.isReadOnly ? 0 : 60}
                                                            questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                            questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                                                            isFFF={true}
                                                            showPreviousQuestion={this.props.showPreviousQuestion}
                                                            showCompetencyIcon={content.questionCategory === 'C1' ||
                                                                content.content.competency && content.content.competency.id === 'YES' ||
                                                                content.skill === 'Comprehension' ? true : false}
                                                        />
                                                    </div>


                                                    {
                                                        this.state.imagePreview && <div style={{
                                                            marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? '0rem' :
                                                                !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                    this.state.showStudentResponse ? '6rem' : '0rem'}`

                                                        }}>
                                                            <ImagePreview modal={this.state.imagePreview} source={this.state.previewUrl} closePreview={this.closePreview} categoryThemeId={this.props.categoryThemeId}></ImagePreview>
                                                        </div>
                                                    }


                                                    {
                                                        this.props.isReadOnly && this.state.showOptions ?
                                                            <div className={`mt-3 option-margin-bottom-new`}>
                                                                <RadioGroup options={content.content.options}
                                                                    // onOptionPressed={this.onOptionPressed}
                                                                    isCheckPoint={this.props.isCheckPoint}
                                                                    // isReadOnly={this.props.isReadOnly}
                                                                    categoryThemeId={this.props.categoryThemeId}
                                                                    classText={this.props.classText}
                                                                />
                                                            </div>
                                                            :
                                                            <></>
                                                    }
                                                </div>
                                                :
                                                !this.props.isMultiStep && !this.props.isCheckPoint && !this.props.isReadOnly ?
                                                    <>
                                                        <QuestionTitle title={content.content.title}
                                                            isFeedback={content.content.isFeedback ? true : false}
                                                            isFFF={true}
                                                            queNo={this.props.quesNo ? this.props.quesNo : null}
                                                            noOfDots={this.props.totalSteps}
                                                            activeDot={this.props.quesNo}
                                                            hideBackground={this.props.isMultiStep ? true : false}
                                                            categoryThemeId={this.props.categoryThemeId}
                                                            isAssessment={this.props.isAssessment}
                                                            delegate={this.props.delegate}
                                                            isReadOnly={this.props.isReadOnly}
                                                            showOptions={this.state.showOptions}
                                                            toggleOptions={() => this.toggleOptions()}
                                                            questions={this.props.questions}
                                                            totalQuestions={this.props.totalQuestions}
                                                            activePage={this.props.activePage}
                                                            isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                            showStudentResponse={this.state.showStudentResponse}
                                                            singleSelectDelegate={this}
                                                            isPlaying={this.state.isPlaying}
                                                            questionTime={this.props.isReadOnly ? 0 : 10}
                                                            questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                            questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                                                            isSingleImageWidthHigh={this.state.imageWidth < 1010 && !content.content.displayQuestionImageAtBottom ? false : true}
                                                            showPreviousQuestion={this.props.showPreviousQuestion}
                                                            showCompetencyIcon={content.questionCategory === 'C1' ||
                                                                content.content.competency && content.content.competency.id === 'YES' ||
                                                                content.skill === 'Comprehension' ? true : false}
                                                        />
                                                        {
                                                            content.content.images.length ?
                                                                <div className="d-flex mt-2">
                                                                    {
                                                                        <div className="question-image-wrapper d-flex">
                                                                            {
                                                                                content.content.images.map(image => (
                                                                                    <div className=" "
                                                                                        style={{
                                                                                            marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "22rem" : '15rem' :
                                                                                                !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.2rem" :
                                                                                                    this.state.showStudentResponse ? '7rem' : '1rem'}`
                                                                                        }}>
                                                                                        <img className="question-image-size-for-bottom-image" src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>

                                                                    }

                                                                    <div><img className='expand-icon ml-1 mr-3 cursor-pointer' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img></div>
                                                                </div>
                                                                : <></>
                                                        }
                                                        {
                                                            this.state.imagePreview && <div style={{
                                                                marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "26.5rem" : '15rem' :
                                                                    !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "6.5rem" :
                                                                        this.state.showStudentResponse ? '7rem' : '1rem'}`
                                                            }}>
                                                                <ImagePreview modal={this.state.imagePreview} source={this.state.previewUrl} closePreview={this.closePreview} categoryThemeId={this.props.categoryThemeId}></ImagePreview>
                                                            </div>
                                                        }
                                                        {
                                                            this.props.isReadOnly && this.state.showOptions ?
                                                                <div className={`mt-3 option-margin-bottom-new`}>
                                                                    <RadioGroup options={content.content.options}
                                                                        // onOptionPressed={this.onOptionPressed}
                                                                        isCheckPoint={this.props.isCheckPoint}
                                                                        // isReadOnly={this.props.isReadOnly}
                                                                        categoryThemeId={this.props.categoryThemeId}
                                                                        classText={this.props.classText}
                                                                    />
                                                                </div>
                                                                :
                                                                <></>
                                                        }
                                                    </>
                                                    :
                                                    <></>


                                    }

                                    <div className="close-icon-wrapper position-absolute cursor-pointer" onClick={() => this.goToPracticeList()}>
                                        <img className="close-icon" src={getImageSource(ImageConstants.CROSS)} />
                                    </div>

                                    {/* {
                                    !this.props.isReadOnly ?

                                        <div className="d-flex justify-content-center mt-2 mb-4"
                                            style={{
                                                marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "28rem" : '14rem' :
                                                    !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1rem" :
                                                        this.state.showStudentResponse ? '6rem' : '0rem'}`
                                            }}>
                                            
                                            <img className="question-divider-image-width-for-elo-title" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, this.props.categoryThemeId)} />
                                        </div>
                                        :
                                        <></>

                                } */}

                                    {!this.props.isCheckPoint && !this.props.isReadOnly && this.props.isResume &&
                                        <div className="d-flex flex-row justify-content-start align-items-center resume-text"
                                            style={{
                                                marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "0.1rem" : '15rem' :
                                                    !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.1rem" :
                                                        this.state.showStudentResponse ? '7rem' : '1rem'}`
                                            }}>
                                            Options have been Shuffled
                                        </div>
                                    }

                                    {/* {// In Place of true add the this.props.isFFF} */}
                                    {
                                        !this.props.isReadOnly ?
                                            <div className={`mt-5 option-margin-bottom-new`}
                                                style={{
                                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "1.2rem" : '15rem' :
                                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1.2rem" :
                                                            this.state.showStudentResponse ? '7rem' : '1rem'}`
                                                }}>
                                                <RadioGroup options={content.content.options}
                                                    onOptionPressed={this.onOptionPressed}
                                                    isCheckPoint={this.props.isCheckPoint}
                                                    isReadOnly={this.props.isReadOnly}
                                                    categoryThemeId={this.props.categoryThemeId}
                                                    isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                    questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                    classText={this.props.classText}
                                                />
                                            </div>
                                            :
                                            <></>
                                    }

                                    {
                                        this.props.isReadOnly && !content.content.isFeedback ?
                                            <>
                                                {/* <div style={{
                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? '14rem' :
                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1rem" :
                                            this.state.showStudentResponse ? '6rem' : '0rem'}`
                                }}> */}

                                                <div className="row align-items-center"
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "0rem" : '14rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                    }}>
                                                    <div className="column-max-width col-1 pr-0 mr-0 d-flex align-items-center" >
                                                        <div className="question-number-circle">
                                                            <div className="question-number">Q {this.props.activePage}/{this.props.totalQuestions}</div>
                                                        </div>

                                                    </div>
                                                    <div className="elo-title col" >{content.eloTitle ? content.eloTitle : this.props.isMultiStep ? this.props.mulipStepQuestion.eloTitle : ''}</div>

                                                </div>

                                                <div className="d-flex justify-content-center mt-2 mb-4"
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "0rem" : '14rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                    }}>
                                                    {/* <div className="soft-divider"></div> */}
                                                    <img className="question-divider-image-width-for-elo-title" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, this.props.categoryThemeId)} />
                                                </div>

                                                <div className={``}
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "2rem" : '14rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "2rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                    }}>
                                                    {this.showTabs()}
                                                </div>

                                                {
                                                    this.state.tabIndex === 1 ?
                                                        <div>
                                                            <div className="row align-items-center mt-5 position-relative" style={{
                                                                marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "0.6rem" : '14rem' :
                                                                    !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.6rem" :
                                                                        this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                            }}>
                                                                {/* {
                                                                this.state.playGif ?
                                                                    <div key={Date.now()} className="position-relative">
                                                                        {
                                                                            <div className="chapter-completed-gif-for-bar-chart">
                                                                                <img src={this.state.gifSrc} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <></>


                                                            } */}

                                                                {/* <div className="column-max-width col-3 pr-0 mr-0 d-flex align-items-center" >
                                                                <div className="question-number-circle">
                                                                    <div className="question-number">Q {this.props.activePage}/{this.props.totalQuestions}</div>
                                                                </div>
                                                                Correct Answer :
                                                            </div> */}
                                                                <div className="ml-0 pl-0 col options-for-read-only option-margin-bottom-new">
                                                                    <RadioGroup options={this.state.options}
                                                                        isCheckPoint={this.props.isCheckPoint}
                                                                        isReadOnly={true}
                                                                        categoryThemeId={this.props.categoryThemeId}
                                                                        isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                        questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                                        classText={this.props.classText}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-center mt-4 mb-4"
                                                                style={{
                                                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "2.5rem" : '14rem' :
                                                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "2.5rem" :
                                                                            this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                                }}>
                                                                {/* <div className="soft-divider"></div> */}
                                                                <img className="question-divider-image-width-for-elo-title" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, this.props.categoryThemeId)} />
                                                            </div>
                                                            <AssessmentQuote
                                                                questions={this.props.questions}
                                                                isMultiStep={this.props.isMultiStep}
                                                                caseStudySkillHash={this.state.caseStudySkillHash}
                                                                totalQuestions={this.props.totalQuestions}
                                                                quote={content.content.quote}
                                                                activePage={this.props.activePage}
                                                                isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                showStudentResponse={this.state.showStudentResponse}
                                                                options={this.state.options}
                                                                studentResponseCount={this.state.studentResponseCount}
                                                                studentList={this.state.studentList}
                                                            />
                                                        </div>
                                                        :
                                                        <></>
                                                }
                                                {
                                                    this.state.tabIndex === 2 ?
                                                        <div className="scroll-in-solution">
                                                            {
                                                                !this.props.isCheckPoint && this.props.isMultiStep && !this.props.isReadOnly ?
                                                                    <>
                                                                        {this.getMultiStepStemQuestion()}

                                                                        {this.getMultiStepQuestion(content)}
                                                                    </>
                                                                    :
                                                                    !this.props.isMultiStep && !this.props.isCheckPoint && this.props.isReadOnly && content.content.images.length === 1 && this.state.imageWidth < 1010 && !content.content.displayQuestionImageAtBottom ?
                                                                        <div className="d-flex align-items-start">
                                                                            <QuestionTitle title={content.content.title}
                                                                                queNo={this.props.quesNo ? this.props.quesNo : null}
                                                                                noOfDots={this.props.totalSteps}
                                                                                activeDot={this.props.quesNo}
                                                                                hideBackground={this.props.isMultiStep ? true : false}
                                                                                categoryThemeId={this.props.categoryThemeId}
                                                                                isAssessment={this.props.isAssessment}
                                                                                delegate={this.props.delegate}
                                                                                isReadOnly={this.props.isReadOnly}
                                                                                showOptions={this.state.showOptions}
                                                                                toggleOptions={() => this.toggleOptions()}
                                                                                questions={this.props.questions}
                                                                                totalQuestions={this.props.totalQuestions}
                                                                                activePage={this.props.activePage}
                                                                                isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                                showStudentResponse={this.state.showStudentResponse}
                                                                                singleSelectDelegate={this}
                                                                                isPlaying={this.state.isPlaying}
                                                                                questionTime={this.props.isReadOnly ? 0 : 60}
                                                                                questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                                                questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                                                                                isFFF={true}
                                                                                showPreviousQuestion={this.props.showPreviousQuestion}
                                                                                showCompetencyIcon={content.questionCategory === 'C1' ||
                                                                                    content.content.competency && content.content.competency.id === 'YES' ||
                                                                                    content.skill === 'Comprehension' ? true : false}
                                                                            />
                                                                            {
                                                                                content.content.images.length ?
                                                                                    <div className="d-flex mt-2">
                                                                                        {
                                                                                            <div className="question-image-wrapper d-flex">
                                                                                                {
                                                                                                    content.content.images.map(image => (
                                                                                                        <div className=" "
                                                                                                            style={{
                                                                                                                marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? '0rem' :
                                                                                                                    !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "0.5rem" :
                                                                                                                        this.state.showStudentResponse ? '6rem' : '0rem'}`

                                                                                                            }}>
                                                                                                            <img className="question-image-size" style={{ maxWidth: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? "none" : ''}` }}
                                                                                                                src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                                                                        </div>
                                                                                                    ))
                                                                                                }
                                                                                            </div>
                                                                                        }
                                                                                        <div><img className='expand-icon ml-1 mr-3 cursor-pointer' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img></div>
                                                                                    </div>
                                                                                    : <></>
                                                                            }
                                                                            {
                                                                                this.state.imagePreview && <div style={{
                                                                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "26.5rem" : '15rem' :
                                                                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "6.5rem" :
                                                                                            this.state.showStudentResponse ? '7rem' : '1rem'}`
                                                                                }}>
                                                                                    <ImagePreview modal={this.state.imagePreview} source={this.state.previewUrl} closePreview={this.closePreview} categoryThemeId={this.props.categoryThemeId}></ImagePreview>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        !this.props.isMultiStep && !this.props.isCheckPoint && this.props.isReadOnly ?
                                                                            <>
                                                                                <QuestionTitle title={content.content.title}
                                                                                    isFFF={true}
                                                                                    queNo={this.props.quesNo ? this.props.quesNo : null}
                                                                                    noOfDots={this.props.totalSteps}
                                                                                    activeDot={this.props.quesNo}
                                                                                    hideBackground={this.props.isMultiStep ? true : false}
                                                                                    categoryThemeId={this.props.categoryThemeId}
                                                                                    isAssessment={this.props.isAssessment}
                                                                                    delegate={this.props.delegate}
                                                                                    isReadOnly={this.props.isReadOnly}
                                                                                    showOptions={this.state.showOptions}
                                                                                    toggleOptions={() => this.toggleOptions()}
                                                                                    questions={this.props.questions}
                                                                                    totalQuestions={this.props.totalQuestions}
                                                                                    activePage={this.props.activePage}
                                                                                    isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                                    showStudentResponse={this.state.showStudentResponse}
                                                                                    singleSelectDelegate={this}
                                                                                    isPlaying={this.state.isPlaying}
                                                                                    questionTime={this.props.isReadOnly ? 0 : 10}
                                                                                    questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                                                    questionImages={content.content.images && content.content.images.length ? content.content.images : ''}
                                                                                    isSingleImageWidthHigh={this.state.imageWidth < 1010 && !content.content.displayQuestionImageAtBottom ? false : true}
                                                                                    showPreviousQuestion={this.props.showPreviousQuestion}
                                                                                    showCompetencyIcon={content.questionCategory === 'C1' ||
                                                                                        content.content.competency && content.content.competency.id === 'YES' ||
                                                                                        content.skill === 'Comprehension' ? true : false}
                                                                                />
                                                                                {
                                                                                    content.content.images.length ?
                                                                                        <div className="d-flex mt-2">
                                                                                            {
                                                                                                <div className="question-image-wrapper d-flex">
                                                                                                    {
                                                                                                        content.content.images.map(image => (
                                                                                                            <div className=" "
                                                                                                                style={{
                                                                                                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "26.5rem" : '15rem' :
                                                                                                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "6.5rem" :
                                                                                                                            this.state.showStudentResponse ? '7rem' : '1rem'}`
                                                                                                                }}>
                                                                                                                <img className="question-image-size-for-bottom-image" src={image.imageUrl} categoryThemeId={this.props.categoryThemeId} />
                                                                                                            </div>
                                                                                                        ))
                                                                                                    }
                                                                                                </div>

                                                                                            }
                                                                                            <div><img className='expand-icon ml-1 mr-3 cursor-pointer' onClick={() => this.openPreview(content.content.images[0].imageUrl)} style={{}} src={getImageSource(ImageConstants.EXPAND)}></img></div>
                                                                                        </div>
                                                                                        : <></>
                                                                                }
                                                                                {
                                                                                    this.state.imagePreview && <div style={{
                                                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "26.5rem" : '15rem' :
                                                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "6.5rem" :
                                                                                                this.state.showStudentResponse ? '7rem' : '1rem'}`
                                                                                    }}>
                                                                                        <ImagePreview modal={this.state.imagePreview} source={this.state.previewUrl} closePreview={this.closePreview} categoryThemeId={this.props.categoryThemeId}></ImagePreview>
                                                                                    </div>
                                                                                }
                                                                            </>
                                                                            :
                                                                            <></>
                                                            }
                                                            <div className="d-flex justify-content-center mt-2 mb-4"
                                                                style={{
                                                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "1.5rem" : '14rem' :
                                                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1.5rem" :
                                                                            this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                                }}>
                                                                {/* <div className="soft-divider"></div> */}
                                                                <img className="question-divider-image-width-for-elo-title" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, this.props.categoryThemeId)} />
                                                            </div>
                                                            {
                                                                showSolution ?
                                                                    <div>
                                                                        <div className="summary-solution-wrapper"
                                                                            style={{
                                                                                marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "1.5rem" : '14rem' :
                                                                                    !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1.5rem" :
                                                                                        this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                                            }}>
                                                                            <SummarySoultions forQuestion={true} solutionSteps={!this.props.isMultiStep ? this.props.content.content.solutionSteps : this.props.mulipStepQuestion.content.solutionSteps} categoryId={this.props.categoryThemeId}></SummarySoultions>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className={`ml-2 mt-3 options-for-read-only option-margin-bottom-new`}>
                                                                        <RadioGroup options={this.state.options}
                                                                            // onOptionPressed={this.onOptionPressed}
                                                                            isCheckPoint={this.props.isCheckPoint}
                                                                            isReadOnly={true}
                                                                            categoryThemeId={this.props.categoryThemeId}
                                                                            isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                            questionImageExist={content.content.images && content.content.images.length ? true : false}
                                                                            classText={this.props.classText}
                                                                        />
                                                                    </div>
                                                            }

                                                        </div>

                                                        :
                                                        <></>
                                                }
                                                {
                                                    this.state.tabIndex === 3 ?
                                                        <div>
                                                            <div className="video-content-wrapper"
                                                                style={{
                                                                    marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "1rem" : '1rem' :
                                                                        !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1rem" :
                                                                            this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                                }}>
                                                                <video
                                                                    key={content.videoUrl}
                                                                    className='cursor-pointer'
                                                                    src={content.videoUrl}
                                                                    playsInline
                                                                    muted={false}
                                                                    controls
                                                                    controlsList="nodownload"
                                                                    poster={getImageSource(ImageConstants.VIDEO_POSTER)}
                                                                    // url={obj.src}
                                                                    // delegate={this.delegate}
                                                                    // ref={ref => this.videoRef[this.videoCount++] = ref}
                                                                    ref={this.videoRef}
                                                                    // onPlay={() => this.props.playSingleVideo && this.props.playSingleVideo(this.videoRef, obj.src)}
                                                                    // onTimeUpdate={() => this.props.updateTimePlayed && this.props.updateTimePlayed(this.videoRef, obj.src)}
                                                                    style={{
                                                                        zIndex: 1,
                                                                        borderRadius: '10px',
                                                                        // backgroundColor: (this.theme && this.theme.secondaryColors.groupingDropBoxHeader) ? this.theme.secondaryColors.groupingDropBoxHeader : Colors.appTheme.purple,
                                                                        justifyContent: 'center',
                                                                        width: !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? '75%' : "100%",
                                                                        // height: this.props.height ? this.props.height : "246px",
                                                                        objectFit: "fill"
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        :
                                                        <></>
                                                }

                                                {
                                                    this.state.tabIndex === 4 && this.props.showLeaderboard ?
                                                        <div>
                                                            {
                                                                this.props.isReadOnly && this.state.isReload ?
                                                                    <>
                                                                        <Leaderboard
                                                                            totalQuestions={this.props.totalQuestions}
                                                                            questions={this.props.questions}
                                                                            quote={this.props.isMultiStep ? this.props.mulipStepQuestion.content.quote : content.content.quote}
                                                                            activePage={this.props.activePage}
                                                                            isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                            showStudentResponse={this.state.showStudentResponse}
                                                                            showLeaderboard={this.props.showLeaderboard}
                                                                            leaderboardLimit={this.props.leaderboardLimit}
                                                                            chapterTitle={this.props.chapterTitle}
                                                                            showLargeStudentResponseSideBar={this.props.showLargeStudentResponseSideBar}
                                                                            timeListHash={this.state.timeListHash}
                                                                            showQuestionLeaderBoard={false}
                                                                            leaderboardData={this.state.leaderboardData}
                                                                            studentListHash={this.state.studentListHash}

                                                                        />
                                                                    </>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                        :
                                                        <></>
                                                }

                                                {
                                                    this.state.tabIndex === 5 && this.props.showLeaderboard ?
                                                        <div>
                                                            {
                                                                this.props.isReadOnly && this.state.isReload ?
                                                                    <>
                                                                        <Leaderboard
                                                                            totalQuestions={this.props.totalQuestions}
                                                                            questions={this.props.questions}
                                                                            quote={this.props.isMultiStep ? this.props.mulipStepQuestion.content.quote : content.content.quote}
                                                                            activePage={this.props.activePage}
                                                                            isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                            showStudentResponse={this.state.showStudentResponse}
                                                                            showLeaderboard={this.props.showLeaderboard}
                                                                            leaderboardLimit={this.props.leaderboardLimit}
                                                                            chapterTitle={this.props.chapterTitle}
                                                                            showLargeStudentResponseSideBar={this.props.showLargeStudentResponseSideBar}
                                                                            timeListHash={this.state.timeListHash}
                                                                            showQuestionLeaderBoard={true}
                                                                            leaderboardData={this.state.leaderboardData}
                                                                            studentListHash={this.state.studentListHash}

                                                                        />
                                                                    </>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                        :
                                                        <></>
                                                }

                                            </>
                                            :
                                            this.props.isReadOnly && content.content.isFeedback ?
                                                <div className=""
                                                    style={{
                                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "20rem" : '14rem' :
                                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "1rem" :
                                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                                    }}>
                                                    <div className="countingwell-logo-wrapper d-flex justify-content-between align-items-center" >
                                                        <img className="countingwell-logo-size" src={getImageSource(ImageConstants.COUNTINGWELL_LOGO)} />
                                                        {
                                                            this.props.showLeaderboard ?
                                                                <div className="button-wrapper-for-overall-leaderboard cursor-pointer"
                                                                    onClick={() => this.showOverallLeaderboard()}>
                                                                    <div>View Overall Leaderboard</div>
                                                                </div>
                                                                :
                                                                <></>
                                                        }

                                                    </div>

                                                    {
                                                        this.state.viewOverallLeaderboard ?
                                                            <>
                                                                <Leaderboard
                                                                    totalQuestions={this.props.totalQuestions}
                                                                    questions={this.props.questions}
                                                                    quote={this.props.isMultiStep ? this.props.mulipStepQuestion.content.quote : content.content.quote}
                                                                    activePage={this.props.activePage - 1}
                                                                    isFullScreenMode={!this.layoutShared.state.showLayoutBar}
                                                                    showStudentResponse={this.state.showStudentResponse}
                                                                    showLeaderboard={this.props.showLeaderboard}
                                                                    leaderboardLimit={this.props.leaderboardLimit}
                                                                    chapterTitle={this.props.chapterTitle}
                                                                    showLargeStudentResponseSideBar={this.props.showLargeStudentResponseSideBar}
                                                                    timeListHash={this.state.timeListHash}
                                                                    showQuestionLeaderBoard={true}
                                                                    leaderboardData={this.state.leaderboardData}
                                                                    studentListHash={this.state.studentListHash}

                                                                />
                                                            </>
                                                            :

                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <img className='great-job-image' src={getImageSource(ImageConstants.GREAT_JOB_IMAGE)} />
                                                                    <div className="keep-learning-text">Keep learning. Keep growing. See you in the next lesson!</div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <img className="student-excersize-image" src={getImageSource(ImageConstants.STUDENT_EXCERSIZE_IMAGE)} />
                                                                </div>
                                                            </div>
                                                    }



                                                </div>
                                                :
                                                <></>
                                    }
                                </div>


                                {/* {
                                !this.props.isReadOnly && content.content.isFeedback ?
                                    <div className="d-flex feedback-images align-items-center justify-content-center" style={{
                                        marginLeft: `${!this.layoutShared.state.showLayoutBar && this.state.showStudentResponse ? true ? "20rem" : '14rem' :
                                            !this.layoutShared.state.showLayoutBar && !this.state.showStudentResponse ? "8rem" :
                                                this.state.showStudentResponse ? '6rem' : '0rem'}`
                                    }}>
                                        <img className="feedback-image-size" src={getImageSource(ImageConstants.FEEDBACK_1)}></img>
                                        <img className="feedback-image-size" src={getImageSource(ImageConstants.FEEDBACK_2)}></img>
                                        <img className="feedback-image-size" src={getImageSource(ImageConstants.FEEDBACK_3)}></img>
                                    </div>
                                    :
                                    <></>
                            } */}





                                {/* <div className="">
                    {!this.props.isCheckPoint && !this.props.isMultiStep && <AssessmentFooter userAnswerStatus={this.props.userAnswerStatus} isFromViewCorrectAnswer={this.props.isFromViewCorrectAnswer} isReadOnly={this.props.isReadOnly} delegate={this.props.delegate} categoryThemeId={this.props.categoryThemeId}></AssessmentFooter>}
                </div> */}
                                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                                    multiline={true}
                                    place='right'
                                    type='light' effect='solid'
                                    event="mouseover mouseenter"
                                    eventOff="mouseleave mouseout scroll mousewheel blur" />
                                {
                                    this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="top-center" /></div> : <></>
                                }
                            </div>
                        </div>

                    :
                    <></>)
                }

            </ScaledCanvas>
        );
    }
}


export default SingleSelect;